import React, { setState, useMemo, memo, useEffect, useState, useRef, useCallback } from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend, 
    RadialLinearScale,
    ArcElement
} from "chart.js";

import { Pie } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line, Bar } from "react-chartjs-2";
import { v4 as uuidv4 } from 'uuid';
import Statistics from "statistics.js";
import DataTable from './DataTable.jsx';
import Table from './ReactTable.js';
import getGradeValue from './getGradeValue.js';
import getGPAColor from './getGPAColor.js';
import getPassRateColor from './getPassRateColor.js';
import getActualUnitsColor from './getActualUnitsColor.js';
import sleep from './sleep.js';
import { compareNumericString, compareString } from './Comparison.jsx';
import calculateComposite from './calculateComposite.js'
import CyGraph from './cy.js';
import { glowLinePlugin } from './CytoscapePlugins.js';
import { dotStream } from 'ldrs'
import fcose from "cytoscape-fcose";
import { Rnd } from 'react-rnd';
import openFloatingModal from './openFloatingModal.jsx';
import openHtmlDocModal from './openHtmlDocModal.jsx';
import { getGradient } from './getGradient.js';
import { percentile } from './percentile';
import { studentHeader, tableHeaders, forecastTable, tableHeaderClass, studentDataHeader, tutorDataHeader} from './TableHeaders.jsx';
import { chartOptions, chartOptionsMega, statisticsChartOptions } from './ChartOptions.js';
import { historicalGradesBarChartBuilder}  from './historicalGradesBarChartBuilder.js';
import { statisticsToBarChartDataBuilder} from './statisticsToBarChartDataBuilder.js';
import { pieChartBuilder } from './pieChartBuilder.js';
import { valToGray, generateBrightColors } from './colorHelpers.js';
import { getGPA } from './getGPA.js';
import { average } from './average.js';
import { uniqueSort } from './uniqueSort.js';
import { ExploreButton } from './ExploreButton.js';
import { Sparklines, SparklinesLine, SparklinesReferenceLine, SparklinesSpots } from 'react-sparklines';
import { Button } from 'react-bootstrap';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react';
import { ClusterDashboard } from './ClusterDashboard.jsx';
dotStream.register()
ChartJS.register(glowLinePlugin, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, RadialLinearScale, ArcElement, ChartDataLabels );
let tableNoHistoryData = [];
let forecastCharts = [];
let fullChartData = [];
let forecastFinal;
let forecastChart;
let classStatisticsFinal;
let classTableFinal;
let tutorChart;
let minIndexMatch = 0.75
const similarityThreshold = 0.25;


const GradeAcademy = memo(function GradeAcademy(props) {
    const hasRunOnce = useRef(false);
    const tableData = [];
    const courseData = [];
    // Student Data Static
    let studentData = [];

    let newTableData = [];
    let tutorData = [];
    let gradeReport = [];
    const [loading, setLoading] = React.useState(true);
    const [loadingMessage, setLoadingMessage] = React.useState('Loading...');
    let totalGPAForStudent = [];
    let latestCompositeForStudent = [];
    let latestGPAColorForStudent = [];
    let chartColors = [];
    let graphElements = [];
    let studentCompositeColor = [];
    let processed = props.processedData;
    let courses = props.courseData[0];
    console.log(courses);
    let enrollment = props.enrollment;
    let subjectData = props.subjectData;
    let statisticsChart = [];
    let hasPreviousData = [];
    let dataStatistics = [];
    let courseGPA = [];
    let courseDataCount = [];
    let combinationChart = [];
    let returningStudentCount = 0;
    let noRegistrationCount = 0;
    let newStudentCount = 0;
    let combinationRef = React.createRef();
    combinationChart['datasets'] = [];
    combinationChart['labels'] = [];
    let courseCounts = [];
    let tutorFirst = [];
    let studentNotes = [];
    let summary = [];
    let kMeansColors = [];
    let groupColors = [];
    let networkInfo = [];
    networkInfo['kmeans'] = [];
    networkInfo['group'] = [];
    networkInfo['subject'] = [];
    
   
    // -----------------------------------
    // B) From newGraphData (pre-rendering)
    // -----------------------------------
    function computeClusterConnectednessFromElements(newGraphData, members, opts = {}) {
    const {
        includeConnections = new Set(["similarity"]),
        directed = false,
    } = opts;

    const memberSet = new Set(members.map(String));
    const n = memberSet.size;

    if (n <= 1) {
        return {
        nStudents: n,
        internalEdges: 0,
        possibleEdges: 0,
        density: 0,
        avgDegree: 0,
        avgEdgeWeight: null,
        edgeTypeCounts: {},
        };
    }

    const edges = newGraphData
        .map((x) => x?.data)
        .filter((d) => d && d.source && d.target); // edge records

    const internal = edges.filter((e) => {
        const src = String(e.source);
        const tgt = String(e.target);
        const conn = e.connection;

        if (!includeConnections.has(conn)) return false;
        return memberSet.has(src) && memberSet.has(tgt);
    });

    const m = internal.length;
    const possibleEdges = directed ? n * (n - 1) : (n * (n - 1)) / 2;
    const density = possibleEdges > 0 ? m / possibleEdges : 0;
    const avgDegree = n > 0 ? (2 * m) / n : 0;

    let wSum = 0, wN = 0;
    const edgeTypeCounts = {};
    for (const e of internal) {
        const conn = e.connection || "unknown";
        edgeTypeCounts[conn] = (edgeTypeCounts[conn] || 0) + 1;

        const w = Number(e.similarityVal ?? e.similarity ?? NaN);
        if (Number.isFinite(w)) { wSum += w; wN++; }
    }

    return {
        nStudents: n,
        internalEdges: m,
        possibleEdges,
        density,
        avgDegree,
        avgEdgeWeight: wN ? (wSum / wN) : null,
        edgeTypeCounts,
    };
    }

    /**
     * OPTIONAL: a simple "cohesion" score you can show in UI:
     * - density (0..1) is already good, but you can emphasize weight if present.
     */
    function cohesionScore(conn) {
    // If avgEdgeWeight is similarity in [0..1], blend it with density.
    const w = (conn.avgEdgeWeight == null) ? 0 : conn.avgEdgeWeight;
    return 0.6 * conn.density + 0.4 * w;
    }
    /**
     * Organize student course rows into statistically meaningful cluster summaries
     * and produce Chart.js-ready datasets.
     *
     * @param {Array<Object>} rows - course-level rows (like your sample)
     * @param {Object} opts
     * @returns {Object} clusterStats
     */
    function buildClusterStatsAndCharts(rows, opts = {}) {
    const {
        // Optional: limit subjects shown in charts
        topSubjects = 20,
        // Optional: if your gradeEarned is already quality points per unit, set false
        // In your sample, gradeEarned looks like per-unit grade points (0..4),
        // so qualityPoints = gradeEarned * units.
        gradeEarnedIsPerUnit = true,
    } = opts;

    // ---------- helpers ----------
    const toNum = (v) => (v == null || v === "" ? NaN : Number(v));

    const courseToSubject = (courseStr) => {
        // "COMP101" -> "COMP"
        const m = String(courseStr).match(/^[A-Z]+/i);
        return m ? m[0].toUpperCase() : "UNK";
    };

    const weightedMean = (pairs) => {
        // pairs = [{x, w}]
        let sw = 0, sxw = 0;
        for (const { x, w } of pairs) {
        if (!Number.isFinite(x) || !Number.isFinite(w) || w <= 0) continue;
        sw += w;
        sxw += x * w;
        }
        return sw > 0 ? sxw / sw : NaN;
    };

    const median = (arr) => {
        const a = arr.filter(Number.isFinite).slice().sort((x, y) => x - y);
        if (!a.length) return NaN;
        const mid = Math.floor(a.length / 2);
        return a.length % 2 ? a[mid] : (a[mid - 1] + a[mid]) / 2;
    };

    // ---------- 1) Normalize rows ----------
    const norm = rows.map((r) => {
        const units = toNum(r.units);
        const gradeEarned = toNum(r.gradeEarned);
        const qp = gradeEarnedIsPerUnit ? gradeEarned * units : gradeEarned;

        return {
        studentID: String(r.studentID),
        term: String(r.term),
        termGPA: toNum(r.termGPA),
        course: String(r.course),
        subject: courseToSubject(r.course),
        gradeEarned,
        units,
        qualityPoints: qp,
        gradeAverage: toNum(r.gradeAverage),
        gradeDifference: toNum(r.gradeDifference),
        };
    });

    // ---------- 2) Cluster-wide aggregates ----------
    const totalUnits = norm.reduce((s, r) => s + (Number.isFinite(r.units) ? r.units : 0), 0);
    const totalQualityPoints = norm.reduce((s, r) => s + (Number.isFinite(r.qualityPoints) ? r.qualityPoints : 0), 0);

    const clusterGPA_weighted = totalUnits > 0 ? totalQualityPoints / totalUnits : NaN;

    // ---------- 3) Student-level term GPA distribution (more statistically meaningful) ----------
    // Build per-student per-term GPA from underlying courses (weighted by units).
    const studentTermAgg = new Map(); // key `${student}|${term}` -> { qp, units }
    for (const r of norm) {
        const key = `${r.studentID}|${r.term}`;
        if (!studentTermAgg.has(key)) studentTermAgg.set(key, { qp: 0, units: 0, studentID: r.studentID, term: r.term });
        const obj = studentTermAgg.get(key);
        if (Number.isFinite(r.qualityPoints)) obj.qp += r.qualityPoints;
        if (Number.isFinite(r.units)) obj.units += r.units;
    }
    const studentTermGPAs = [];
    for (const v of studentTermAgg.values()) {
        const gpa = v.units > 0 ? v.qp / v.units : NaN;
        studentTermGPAs.push(gpa);
    }
    const clusterTermGPA_mean = studentTermGPAs.length ? studentTermGPAs.reduce((a, b) => a + (Number.isFinite(b) ? b : 0), 0) / studentTermGPAs.filter(Number.isFinite).length : NaN;
    const clusterTermGPA_median = median(studentTermGPAs);

    // ---------- 4) Per-term cluster time series (weighted) ----------
    const termAgg = new Map(); // term -> { qp, units }
    for (const r of norm) {
        if (!termAgg.has(r.term)) termAgg.set(r.term, { qp: 0, units: 0, term: r.term });
        const t = termAgg.get(r.term);
        if (Number.isFinite(r.qualityPoints)) t.qp += r.qualityPoints;
        if (Number.isFinite(r.units)) t.units += r.units;
    }
    const termSeries = Array.from(termAgg.values())
        .map((t) => ({ term: t.term, gpa: t.units > 0 ? t.qp / t.units : NaN, units: t.units }))
        .sort((a, b) => Number(a.term) - Number(b.term));

    // ---------- 5) Per-subject aggregates ----------
    const subjAgg = new Map(); // subject -> metrics
    for (const r of norm) {
        const s = r.subject;
        if (!subjAgg.has(s)) {
        subjAgg.set(s, {
            subject: s,
            courseCount: 0,
            units: 0,
            qualityPoints: 0,
            gradeDiffSum: 0,
            gradeDiffN: 0,
        });
        }
        const obj = subjAgg.get(s);
        obj.courseCount += 1;
        if (Number.isFinite(r.units)) obj.units += r.units;
        if (Number.isFinite(r.qualityPoints)) obj.qualityPoints += r.qualityPoints;
        if (Number.isFinite(r.gradeDifference)) {
        obj.gradeDiffSum += r.gradeDifference;
        obj.gradeDiffN += 1;
        }
    }

    let subjects = Array.from(subjAgg.values()).map((s) => ({
        ...s,
        gpaWeighted: s.units > 0 ? s.qualityPoints / s.units : NaN,
        avgGradeDifference: s.gradeDiffN > 0 ? s.gradeDiffSum / s.gradeDiffN : NaN,
    }));

    // Keep charts readable: sort by volume and take top N
    subjects.sort((a, b) => b.units - a.units);
    const subjectsTop = subjects.slice(0, topSubjects);

    // ---------- 6) Chart.js-ready datasets ----------
    const chartjs = {
        termGpaLine: {
        labels: termSeries.map((t) => t.term),
        datasets: [
            {
            label: "Cluster GPA (weighted by units)",
            data: termSeries.map((t) => Number.isFinite(t.gpa) ? Number(t.gpa.toFixed(2)) : null),
            tension: 0.25,
            },
        ],
        },

        subjectCourseCountBar: {
        labels: subjectsTop.map((s) => s.subject),
        datasets: [
            {
            label: "Courses taken (count)",
            data: subjectsTop.map((s) => s.courseCount),
            },
        ],
        },

        subjectQualityPointsBar: {
        labels: subjectsTop.map((s) => s.subject),
        datasets: [
            {
            label: "Quality Points (sum)",
            data: subjectsTop.map((s) => Number(s.qualityPoints.toFixed(2))),
            },
        ],
        },

        subjectGpaBar: {
        labels: subjectsTop.map((s) => s.subject),
        datasets: [
            {
            label: "Subject GPA (weighted by units)",
            data: subjectsTop.map((s) => Number.isFinite(s.gpaWeighted) ? Number(s.gpaWeighted.toFixed(2)) : null),
            },
        ],
        },

        subjectGradeDiffBar: {
        labels: subjectsTop.map((s) => s.subject),
        datasets: [
            {
            label: "Avg gradeDifference (vs course average)",
            data: subjectsTop.map((s) => Number.isFinite(s.avgGradeDifference) ? Number(s.avgGradeDifference.toFixed(2)) : null),
            },
        ],
        },
    };

    // ---------- return stats ----------
    return {
        cluster: {
        totalStudents: new Set(norm.map((r) => r.studentID)).size,
        totalCourses: norm.length,
        totalUnits,
        totalQualityPoints,
        gpaWeighted: clusterGPA_weighted,            // overall best single number
        termGpaMean: clusterTermGPA_mean,            // mean of student-term GPAs
        termGpaMedian: clusterTermGPA_median,        // robust central tendency
        },
        termSeries,
        subjects,       // full list
        subjectsTop,    // trimmed list used in charts
        chartjs,
    };
    }

    const [reloading, setReloading] = useState(false);

    const reloadConfirm = () => {
        if (reloading) return; // ignore if already triggered
        setReloading(true);

        if (window.confirm("Are you sure you want to start over?")) {
            window.location.reload();
        } else {
            alert("Returned to dashboard.");
            setReloading(false); // allow retry if they cancel
        }
    };
    const buildAcademyData = useCallback(() => {
        let coursesOrdered = Object.keys(courses).sort().reduce(
            (obj, key) => {
                obj[key] = courses[key];
                return obj;
            }, 
            {}
            );
            console.log(coursesOrdered);
        enrollment.forEach((enroll) => {
            // console.log(enroll);
            if (!chartColors[enroll.SUBJECT_CODE]) {
                chartColors[enroll.SUBJECT_CODE] = 1;
            }
            let thisCourse = enroll.SUBJECT_CODE + enroll.COURSE_NUMBER;
            if (!courseCounts[thisCourse]) {
                courseCounts[thisCourse] = 1;
            } else {
                courseCounts[thisCourse]++;
            }
        });
        Object.keys(subjectData[0]).forEach((course) => {
            // console.log(enroll);
            if (!chartColors[course]) {
                chartColors[course] = 1;
            }
        });

        chartColors = generateBrightColors(chartColors, 0);
        Object.keys(coursesOrdered).forEach(function(course) {
            let courseStrippedNumbers = course.replace(/[0-9]/g, '');
            let thisChartData;
            if (coursesOrdered[course]['grades']) {
                thisChartData = historicalGradesBarChartBuilder(course, coursesOrdered[course]['grades']);
            } else {
                thisChartData = historicalGradesBarChartBuilder(course, [0]);
            }
            let gpaSum = 0;
            let gradeSum = 0;
            Object.keys(coursesOrdered[course]['grades']).forEach(function(grade) {
                gpaSum += getGradeValue(grade) * coursesOrdered[course]['grades'][grade]
                gradeSum += coursesOrdered[course]['grades'][grade]
            });
            let gradeLang = '';
            if (gradeSum === 1) {
                gradeLang = "Grade";
            } else {
                gradeLang = "Grades";
            }
            if (gradeSum === 0) {
                console.log("No grades for " + course);
            }
            let averageGrade = (gpaSum/gradeSum).toFixed(2);
            courseGPA[course] = averageGrade;
            // console.log(averageGrade);

            // console.log(courseGPA);
            courseDataCount[course] = gradeSum;
            let useCourse = '';
            if (courseCounts[course]) {
                useCourse = courseCounts[course];
            } else {
                useCourse = 0;
            }
            // setTableClassData(prevData => [...prevData, ]);
            tableData.push({
                //(<a id={student.toString() + "_link"} href={"#" + student.toString()}>{student.toString() }</a>),
                course: course,
                classDataCount: gradeSum,
                currentEnrolledCount: useCourse,
                classAverageGrade: averageGrade
            });
            // somewhere above: const courseData = [];
            // ...
            courseData.push(
            <div id={courseStrippedNumbers} className="gradeCard" key={uuidv4()}>
                <div className="gradeCardInner" style={{ textAlign: "center", position: "relative" }}>
                <div id={course} className="gradeBox" style={{ backgroundColor: getGPAColor(averageGrade) }}>
                    <div className="courseHeader">
                        <p style={{ fontWeight: 500, color: chartColors[courseStrippedNumbers] }}>{course}
                        <br />{averageGrade}
                        </p>
                    </div>
                    <span style={{ fontSize: "8pt", color: "black" }}>(n = {gradeSum}) {gradeLang}</span>
                </div>

                <Bar
                    data={thisChartData}
                    options={{
                    maintainAspectRatio: true,
                    scales: {
                        x: {
                        ticks: { color: "white" },
                        grid: { color: "white" },
                        },
                        y: {
                        ticks: { color: "white" },
                        grid: { color: "white" },
                        },
                    },
                    plugins: {
                        legend: { labels: { color: "white" } },
                        datalabels: {
                            color: 'white',
                            font: { weight: 'bold' },
                        },
                    }}}
                />
                </div>
            </div>
            );

            // setCourseCharts(prevData => [...prevData, ])
        });
        // setLoadingMessage("Processing grade data.");
        processed.forEach((lineDatum) => {
            // setLoadingMessage("Processing grade data.");
            let counter = 0;
            for (const [student, termData] of Object.entries(lineDatum)) {
                const thisStudent = student;
                let englishCourse = '';
                let mathCourse = '';
                counter++;
                let css;
                if (counter % 2 === 0) {
                    css = 'even';
                } else {
                    css = 'odd';
                }
                let previousClassGrades = [];
                let thisStudentProjectedGrades = [];
                let projectedHTML = [];
                let studentEnrollment = enrollment.filter(function (enrolled) {
                    return enrolled.ID.toString() === student.toString();
                });
                let hasClasses = 'No';
                let projectedDifficulty = 0;
                let finalDifficulty = 0;
                let classCount = 0;
                let comparisonVars;
                let gradeCorrelationStats;
                let gradeCorrelationCoefficient = 1;
                
                let nodeData = [];
                let classAverageData = {};
                classAverageData['id'] = '';
                classAverageData['data'] = [];
                classAverageData['label'] = 'Average Class GPA';
                classAverageData['backgroundColor'] = '#fff';
                classAverageData['borderColor'] = '#fff';
                classAverageData['tension'] = .3;
                classAverageData['yAxisID'] = 'y1';
                classAverageData['glow'] = true;

                let aboveOrBelowGrade = [];
                let gradeComparison = [];
                let gpaSlope = [];
                gpaSlope['point1'] = [];
                gpaSlope['point2'] = [];
                gpaSlope['point1']['x'] = 0;
                gpaSlope['point1']['y'] = 0;
                gpaSlope['point2']['y'] = 0;
                gpaSlope['point2']['x'] = 0;

                let studentGPADifference = [];
                try {
                    // Building data for nodal charts.
                    
                        Object.keys(processed).forEach(process => {
                            Object.keys(processed[process]).forEach(function(studentNode) {
                                if (studentNode === student) {
                                    nodeData.push({data: { id: studentNode, label: studentNode, color: '#f5f5f5' }});
                                    let termLength = Object.keys(processed[process][studentNode]).length-1;
                                    let termCounter = 0;
                                    Object.keys(processed[process][studentNode]).forEach(function(term) {
                                        let thisTermGPASum = 0;
                                        if (termCounter === 0) {
                                            gpaSlope['point1']['x'] = 0;
                                            gpaSlope['point1']['y'] = processed[process][studentNode][term].gpa;
                                        }
                                        if (termCounter === termLength) {
                                            gpaSlope['point2']['x'] = termLength;
                                            gpaSlope['point2']['y'] = processed[process][studentNode][term].gpa;
                                            
                                        }
                                        termCounter++;
                                        nodeData.push({data: { id: studentNode + term, label: term, parent: studentNode, color: '#f5f5f5', }});
                                        let processConnections = [];
                                        // console.log(term);
                                        // If this statement isn't included, charts will generate double-connected nodes.
                                        for (let i = 0; i < Object.keys(processed[process][studentNode][term].courses).length; i++) {
                                            const gradeEarned = processed[process][studentNode][term].grades[i];
                                            const units = processed[process][studentNode][term].units[i];
                                            const gradeAverage = courseGPA[processed[process][studentNode][term].courses[i]];
                                            const studentGrade = processed[process][studentNode][term].grades[i];
                                            const classAverageGrade = courseGPA[processed[process][studentNode][term].courses[i]];
                                            let dataToPush = {
                                                studentID: student,
                                                term: term,
                                                termGPA: processed[process][studentNode][term].gpa.toFixed(2),
                                                course: processed[process][studentNode][term].courses[i],
                                                // course: processed[process][studentNode][term].courses[i],
                                                gradeEarned: gradeEarned,
                                                units: units,
                                                gradeAverage: gradeAverage,
                                                gradeDifference: (
                                                Number(studentGrade) -
                                                Number(classAverageGrade)
                                                ).toFixed(2),
                                            };
                                            if (!studentData[student]) {
                                                studentData[student] = [];
                                            }
                                            studentData[student].push(dataToPush);
                                            // setStudentData((prevData) => {
                                            //     // Copy the previous student data
                                            //     const newStudentData = { ...prevData };

                                            //     // If the student doesn't exist yet, initialize their array
                                            //     if (!newStudentData[student]) {
                                            //         newStudentData[student] = [];
                                            //         studentDataStatic[student] = [];
                                            //     }

                                            //     // Add new data for the student
                                            
                                            //     newStudentData[student].push(dataToPush);
                                            //    // Return the updated student data
                                            //     return newStudentData;
                                            // });
                                            // if (!tutorData[processed[process][studentNode][term].courses[i]])
                                            // {
                                            //     tutorData[processed[process][studentNode][term].courses[i]] = [];
                                            //     tutorData[processed[process][studentNode][term].courses[i]]['tutorCandidate'] = [];
                                            //     tutorData[processed[process][studentNode][term].courses[i]]['needsTutor'] = [];
                                            // }
                                            let useTutorFlag = false;
                                            if (processed[process][studentNode][term].grades[i] >= 4.0) {
                                                if (Object.keys(studentEnrollment).length > 0) {
                                                    studentEnrollment.forEach((enrollment) => {
                                                            if (enrollment.ID.toString() === student.toString()) {
                                                                useTutorFlag = true;
                                                            }
                                                        })
                                                }
                                                if (useTutorFlag === true) {
                                                    if (!tutorFirst[processed[process][studentNode][term].courses[i]]) {
                                                        tutorFirst[processed[process][studentNode][term].courses[i]] = '_first';
                                                    } else {
                                                        tutorFirst[processed[process][studentNode][term].courses[i]] = '';
                                                    }
                                                    // tutorTableData.push({
                                                    //     course: processed[process][studentNode][term].courses[i],
                                                    //     courseLink: (<a id={student +"_table_" + processed[process][studentNode][term].courses[i]} href={"#" + processed[process][studentNode][term].courses[i]}>{processed[process][studentNode][term].courses[i]}</a>),
                                                    //     tutorOrNeeds: 'Tutor',
                                                    //     gradeValue: processed[process][studentNode][term].gradesActual[i],
                                                    //     gradeEarned: processed[process][studentNode][term].grades[i],
                                                    //     studentID: (<a id={student.toString() + "_link"} href={"#" + student.toString()}><span id={processed[process][studentNode][term].courses[i] + "_tutor" + tutorFirst[processed[process][studentNode][term].courses[i]]}>{student.toString() }</span></a>),
                                                    //     term: term
                                                    // })
                                                    const course = processed[process][studentNode][term].courses[i];
                                                    const gradeActual = processed[process][studentNode][term].gradesActual[i];
                                                    const gradeEarned = processed[process][studentNode][term].grades[i];
                                                    const courseLink = processed[process][studentNode][term].courses[i];
                                                    tutorData.push({
                                                        course: course,
                                                        courseLink: courseLink,
                                                        tutorOrNeeds: 'Tutor',
                                                        gradeValue: gradeActual,
                                                        gradeEarned: gradeEarned,
                                                        studentID: student,
                                                        term: term
                                                    })
                                                    // setTutorTableData(prevData => [
                                                    //     ...prevData,
                                                    //     {
                                                    //         course: course,
                                                    //         courseLink: courseLink,
                                                    //         tutorOrNeeds: 'Tutor',
                                                    //         gradeValue: gradeActual,
                                                    //         gradeEarned: gradeEarned,
                                                    //         studentID: (
                                                    //             <a id={student.toString() + "_link"} href={"#" + student.toString()}>
                                                    //                 <span id={processed[process][studentNode][term].courses[i] + "_tutor" + tutorFirst[processed[process][studentNode][term].courses[i]]}>
                                                    //                     {student.toString()}
                                                    //                 </span>
                                                    //             </a>
                                                    //         ),
                                                    //         term: term
                                                    //     }
                                                    // ]);
                                                    
                                                }
                                            }
                                            let useTutoringFlag = false;
                                            if (processed[process][studentNode][term].grades[i] < 2.0) {
                                                if (Object.keys(studentEnrollment).length > 0) {
                                                studentEnrollment.forEach((enrollment) => {
                                                            if (enrollment.ID.toString() === student.toString()) {
                                                            if ((enrollment.SUBJECT_CODE + enrollment.COURSE_NUMBER).toString() === processed[process][studentNode][term].courses[i]) {
                                                                // tutorTableData.push({
                                                                //     course: processed[process][studentNode][term].courses[i],
                                                                //     courseLink: (<a id={student +"_table_" + processed[process][studentNode][term].courses[i]} href={"#" + processed[process][studentNode][term].courses[i]}>{processed[process][studentNode][term].courses[i]}</a>),
                                                                //     tutorOrNeeds: 'Needs Tutor',
                                                                //     gradeValue: processed[process][studentNode][term].gradesActual[i],
                                                                //     gradeEarned: processed[process][studentNode][term].grades[i],
                                                                //     studentID: (<a id={student.toString() + "_link"} href={"#" + student.toString()}>{student.toString() }</a>),
                                                                //     term: enrollment.TERM_CODE
                                                                // })
                                                                const course = processed[process][studentNode][term].courses[i];
                                                                const gradeActual = processed[process][studentNode][term].gradesActual[i];
                                                                const gradeEarned = processed[process][studentNode][term].grades[i];
                                                                const courseLink = processed[process][studentNode][term].courses[i];
                                                                tutorData.push({
                                                                    course: course,
                                                                    courseLink: courseLink,
                                                                    tutorOrNeeds: 'Tutor Recommended',
                                                                    gradeValue: gradeActual,
                                                                    gradeEarned: gradeEarned,
                                                                    studentID: student,
                                                                    term: enrollment.TERM_CODE
                                                                })
                                                                // setTutorTableData(prevData => [
                                                                //     ...prevData,
                                                                    
                                                                // ]);
                                                                // if (!studentNotes[student.toString()]) {
                                                                //     studentNotes[student.toString()] = [];
                                                                // }
                                                                studentNotes[student.toString()] = [];
                                                                studentNotes[student.toString()].push('Student may need tutoring for ' + processed[process][studentNode][term].courses[i] + '.')
                                                            }
                                                            }
                                                        })
                                                    }
                                                }

                                        }
                                        if (Object.keys(processed[process][studentNode][term].courses).length === 1) {
                                            for (let i = 0; i < Object.keys(processed[process][studentNode][term].courses).length; i++) {
                                                nodeData.push({data: { id: processed[process][studentNode][term].courses[i], label: processed[process][studentNode][term].courses[i] + "\n(Earned: " + processed[process][studentNode][term].grades[i] + "/Average: " + + courseGPA[processed[process][studentNode][term].courses[i]] + ")", color: getGPAColor(courseGPA[processed[process][studentNode][term].courses[i]]), parent: studentNode + term }});
                                                
                                                thisTermGPASum = courseGPA[processed[process][studentNode][term].courses[i]];
                                                console.log(courseGPA, processed[process][studentNode][term].courses);
                                                try {
                                                classAverageData['data'].push(parseFloat(thisTermGPASum.toFixed(2)));
                                                } catch {
                                                    classAverageData['data'].push(0);
                                                }
                                                gradeComparison.push({ earned: Number(processed[process][studentNode][term].grades[i].toFixed(2)), anticipated: Number(courseGPA[processed[process][studentNode][term].courses[i]])});
                                            }
                                        } else {
                                            thisTermGPASum = courseGPA[processed[process][studentNode][term].courses[0]]
                                            gradeComparison.push({ earned: Number(processed[process][studentNode][term].grades[0].toFixed(2)), anticipated: Number(courseGPA[processed[process][studentNode][term].courses[0]])});

                                            for (let i = 1; i < Object.keys(processed[process][studentNode][term].courses).length; i++) {
                                                gradeComparison.push({ earned: Number(processed[process][studentNode][term].grades[i].toFixed(2)), anticipated: Number(courseGPA[processed[process][studentNode][term].courses[i]])});

                                                for (let j = 0; j < Object.keys(processed[process][studentNode][term].courses).length; j++) {

                                                    if (Object.keys(processed[process][studentNode][term].courses).length === 1) {
                                                        nodeData.push({data: { id: processed[process][studentNode][term].courses[i], label: processed[process][studentNode][term].courses[i] + "\n(Earned: " + processed[process][studentNode][term].grades[i] + "/Average: " + courseGPA[processed[process][studentNode][term].courses[i]] + ")", color: getGPAColor(courseGPA[processed[process][studentNode][term].courses[i]]), parent: studentNode + term }});
                                                        nodeData.push({data: { source: processed[process][studentNode][term].courses[i], target: processed[process][studentNode][term].courses[j], label: processed[process][studentNode][term].gpa.toFixed(2), color: '#f5f5f5', width: .1, color: getGPAColor(processed[process][studentNode][term].gpa.toFixed(2))}});
                                                        // console.log('j loop');
                                                        
                                                    }
                                                    if (processed[process][studentNode][term].courses[i] !== processed[process][studentNode][term].courses[j])
                                                    {  
                                                        if (!(processConnections.includes(processed[process][studentNode][term].courses[i]) && !processConnections.includes(processed[process][studentNode][term].courses[j])))
                                                        {
                                                            let nodeWidth;
                                                            if (processed[process][studentNode][term].gpa.toFixed(2) === '0.0') {
                                                                nodeWidth = .1;
                                                            } else {
                                                                nodeWidth = processed[process][studentNode][term].gpa.toFixed(2);
                                                            }
                                                            nodeData.push({data: { id: processed[process][studentNode][term].courses[i], label: processed[process][studentNode][term].courses[i] + "\n(Earned: " + processed[process][studentNode][term].grades[i] + "/Average: " + + courseGPA[processed[process][studentNode][term].courses[i]] + ")", color: getGPAColor(courseGPA[processed[process][studentNode][term].courses[i]]), parent: studentNode + term }});
                                                            nodeData.push({data: { id: processed[process][studentNode][term].courses[j], label: processed[process][studentNode][term].courses[j] + "\n(Earned: " + processed[process][studentNode][term].grades[j] + "/Average: " + + courseGPA[processed[process][studentNode][term].courses[j]] + ")", color: getGPAColor(courseGPA[processed[process][studentNode][term].courses[j]]), parent: studentNode + term }});
                                                            nodeData.push({data: { source: processed[process][studentNode][term].courses[i], target: processed[process][studentNode][term].courses[j], label: processed[process][studentNode][term].gpa.toFixed(2), width: nodeWidth/1.2, color: getGPAColor(processed[process][studentNode][term].gpa.toFixed(2))}});
                                                            processConnections.push(processed[process][studentNode][term].courses[i]);
                                                            processConnections.push(processed[process][studentNode][term].courses[j]);
                                                        }
                                                    }   
                                                    
                                                }
                                                // console.log(thisTermGPASum);
                                                // console.log(studentNode);
                                                // console.log(processed[process][studentNode]);
                                                // console.log(courseGPA[processed[process][studentNode][term].courses[i]]);
                                                thisTermGPASum = parseFloat(thisTermGPASum) + parseFloat(courseGPA[processed[process][studentNode][term].courses[i]]);
                                                // console.log(studentNode);
                                                // console.log(processed[process][studentNode]);
                                                // console.log(thisTermGPASum);
                                            }
                                            
                                        }
                                        // 5/9/2022
                                        // console.log(processed[process][studentNode][term]);
                                        // console.log(thisTermGPASum);
                                        
                                        let gpaDifference = (processed[process][studentNode][term]['gpa'] - (thisTermGPASum/processed[process][studentNode][term].courses.length));
                                        // console.log(gpaDifference);
                                        // console.log(studentNode);
                                        // console.log(gradeComparison);
                                        aboveOrBelowGrade.push(gpaDifference);
                                        // console.log(Object.keys(processed[process][studentNode][term].courses).length);
                                        classAverageData['data'].push(parseFloat((thisTermGPASum/Object.keys(processed[process][studentNode][term].courses).length)).toFixed(2));
                                    })
                                    // console.log(processed[process][studentNode]);
                                    studentGPADifference[student] = average(aboveOrBelowGrade);


                                }
                                
                            })
                            comparisonVars = {
                                earned: 'metric',
                                anticipated: 'metric'
                            }
                            gradeCorrelationStats = new Statistics(gradeComparison, comparisonVars);
                            // console.log(gradeCorrelationStats);
                            gradeCorrelationCoefficient = gradeCorrelationStats?.correlationCoefficient('anticipated', 'earned') || 1;
                            // console.log(gradeComparison);
                            // console.log(gradeCorrelationCoefficient);
                        })
                    // console.log(tutorData);
                } catch(e) {
                    console.log(e);
                }
                if (Object.keys(studentEnrollment).length > 0) {
                    returningStudentCount++;
                    hasPreviousData.push(student);
                    hasClasses = 'Yes';
                    projectedHTML.push(<h3 style={{textAlign: 'center'}}>Predictive Progress Based on Averages</h3>);
                    projectedHTML.push(<p style={{textAlign: 'center'}}>These are the grades awarded to students for the classes this student is enrolled in, with the student's average performance factored in.<br/><span style={{"color": "#ff0000"}}>These are not grades for the current student.</span></p>);
                    studentEnrollment.forEach((enrollment) => {
                        let thisCourse = enrollment.SUBJECT_CODE + enrollment.COURSE_NUMBER;
                        
                        if (enrollment.SUBJECT_CODE === "MATH") {
                            if (enrollment.COURSE_NUMBER > mathCourse) {
                                mathCourse = enrollment.COURSE_NUMBER;
                            }
                        }
                        if (enrollment.SUBJECT_CODE === "ENGL") {
                            if (enrollment.COURSE_NUMBER > englishCourse) {
                                englishCourse = enrollment.COURSE_NUMBER;
                            }
                        }
                        let gradeLang;
                        if (courseDataCount[thisCourse] === 1) {
                            gradeLang = "Grade";
                        } else {
                            gradeLang = "Grades";
                        }
                        try {
                            classCount++;
                            let thisChartData = historicalGradesBarChartBuilder(thisCourse, courses[thisCourse]['grades']);
                            projectedDifficulty = Number(projectedDifficulty) + Number(courseGPA[thisCourse]);
                            let adjustedForecastGrade = (Number(studentGPADifference[student]) + Number(courseGPA[thisCourse])).toFixed(2);
                            const thisStudentGradeChart = (
                                <>
                                    <div className="gradeCard">
                                        <div
                                        className="gradeCardInner"
                                        key={uuidv4()}
                                        style={{
                                            textAlign: "center",
                                            position: "relative",
                                            /* float: 'left', */ // remove floats when using modern layout
                                            margin: 0,
                                        }}
                                        >
                                        <div
                                            className="gradeBox"
                                            style={{
                                            backgroundColor: getGPAColor(courseGPA[thisCourse]),
                                            color: "black",
                                            /* --- keep inner spacing inside the box --- */
                                            padding: 8,
                                            boxSizing: "border-box",
                                            borderRadius: 10,
                                            overflow: "hidden",       // clip to rounded corners
                                            display: "grid",
                                            gap: 6,                    // replace inner margins
                                            margin: "0 auto",          // center the box if narrower than parent
                                            maxWidth: 420,             // optional: keeps card readable
                                            }}
                                        >
                                            {/* Header pill with no margin; spacing handled by parent gap */}
                                            <div
                                            style={{
                                                backgroundColor: "black",
                                                color: "rgb(193, 221, 136)",
                                                padding: 6,
                                                borderRadius: 8,
                                            }}
                                            >
                                            <p style={{ fontWeight: 500, margin: 0 }}>
                                                <span style={{color: chartColors[enrollment.SUBJECT_CODE]}}>{thisCourse}</span><br/>
                                                {enrollment.TERM_CODE}
                                                <br />
                                                <span style={{color: getGPAColor(courseGPA[thisCourse])}}>{courseGPA[thisCourse]}</span>
                                            </p>
                                            </div>

                                            <span style={{ fontSize: "8pt" }}>
                                            (n = {courseDataCount[thisCourse]}) {gradeLang}
                                            </span>

                                            <div
                                            className="subGradeBox"
                                            style={{
                                                color: "black",
                                                backgroundColor: getGPAColor(adjustedForecastGrade),
                                                padding: 10,
                                                borderRadius: 8,
                                                border: "1px solid black",
                                                /* no margin here; parent gap handles spacing */
                                            }}
                                            >
                                            <span>Forecasted Grade</span>
                                            <br />
                                            <span>Based On Average Performance</span>
                                            <br />
                                            {adjustedForecastGrade}
                                            </div>
                                        </div>

                                        <Bar
                                            className="bar"
                                            data={thisChartData}
                                            options={{
                                                maintainAspectRatio: true,
                                                scales: {
                                                x: {
                                                    ticks: { color: "white" },
                                                    grid: { color: "white" },
                                                },
                                                y: {
                                                    ticks: { color: "white" },
                                                    grid: { color: "white" },
                                                },
                                                },
                                                plugins: {
                                                legend: { labels: { color: "white" } },
                                                datalabels: {
                                                    color: 'white',
                                                    font: { weight: 'bold' },
                                                }
                                                },
                                            }}
                                            />
                                        </div>
                                    </div>
                                </>
                                );

                            thisStudentProjectedGrades.push(thisStudentGradeChart);
                            //   console.log(thisStudentProjectedGrades);
                            } catch (e) {
                            classCount--;
                            console.log(e);
                            thisStudentProjectedGrades.push(<div className="gradeChartCenter" key={uuidv4()} style={{textAlign: 'center', position: 'relative', float: 'left'}}>No data for {thisCourse}</div>);
                        }
                        
                    });
                    finalDifficulty = (projectedDifficulty/classCount).toFixed(2);
                    if (classCount === 0) {
                        finalDifficulty = 0;
                    }
                } else {
                    noRegistrationCount++;
                }


                let lastTwoSlope = 0;
                let dataAggregation = {};
                let unitsPassed = 0;
                let studentUnitSum = 0;
                let termsAttended = 0;
                let termsAttended12 = 0;
                let studentColorGPA = 'green';

                
                // Build the object for each student.
                let studentChart = {};
                studentChart['labels'] = [];
                studentChart['datasets'] = []; 
                studentChart['datasets']['labels'] = [];
                studentChart['datasets']['data'] = [];
                studentChart['backgroundColor'] = '#dadada';
                studentChart['borderColor'] = '#dadada';

                // Build the object for student GPA data.
                let gpaDataset = {};
                gpaDataset['id'] = '';
                gpaDataset['data'] = [];
                gpaDataset['label'] = '';
                gpaDataset['backgroundColor'] = [];
                gpaDataset['borderColor'] = [];
                gpaDataset['datalabels'] = [];
                gpaDataset['yAxisID'] = 'y1';

                // Build the object for unit data
                let unitDataset = {};
                unitDataset['id'] = '';
                unitDataset['data'] = [];
                unitDataset['label'] = '';
                unitDataset['borderColor'] = studentColorGPA;
                unitDataset['yAxisID'] = 'y1';

                let unitsAttempted = {};
                unitsAttempted['id'] = '';
                unitsAttempted['data'] =[];
                unitsAttempted['label'] = '';
                unitsAttempted['borderColor'] = 'darkorange';
                unitsAttempted['datalabels'] = {
                    color: 'darkorange'
                }
                unitsAttempted['yAxisID'] = 'y';

                let unitsActual = {};
                unitsActual['id'] = '';
                unitsActual['data'] = [];
                unitsActual['actualPassed'] = [];
                unitsActual['label'] = '';
                unitsActual['borderColor'] = 'red';
                unitsActual['yAxisID'] = 'y';

                let benefitUtilization = {};
                benefitUtilization['id'] = '';
                benefitUtilization['data'] = [];
                benefitUtilization['label'] = '';
                // benefitUtilization['borderColor'] = unitsActualColor;
                // benefitUtilization['datalabels'] = {
                //     color: unitsActualColor
                // }
                benefitUtilization['yAxisID'] = 'y2';
                let pieChartData = [];
                pieChartData['labels'] = [];
                pieChartData['data'] = [];
                pieChartData['units'] = [];
                pieChartData['grades'] = [];
                for (const [term, grades] of Object.entries(termData)) {
                    var termUnitSum = 0;
                    for (const [subjectIndex, subjectValue] of Object.entries(grades['subjectCodes'])) {
                        // Ensure only qualityPoints > 0 are processed
                        if (grades['units'][subjectIndex] > 0) {
                            // Assign color if not already assigned
                            if (!chartColors[subjectValue]) {
                                chartColors[subjectValue] = 1;
                            }
                            pieChartData['grades'].push(grades['grades'][subjectIndex])
                            pieChartData['units'].push(grades['units'][subjectIndex]);
                            if (!pieChartData['labels'].includes(subjectValue)) {
                                pieChartData['labels'].push(subjectValue);
                            }
                            
                            // Retrieve the current index for this subject
                            const currentSubjectIndex = pieChartData['labels'].indexOf(subjectValue);
                            
                            // Initialize data array for this subject if it doesn't exist yet
                            if (!pieChartData['data'][currentSubjectIndex]) {
                                pieChartData['data'][currentSubjectIndex] = 0;
                            }
                            
                            // Add quality points to the data array
                            pieChartData['data'][currentSubjectIndex] += grades['units'][subjectIndex];
                        }
                        // console.log(grades);

                    }
                    graphElements[student] = [];
                    graphElements[student].push(pieChartData);
                    // let pieChartCourseData = [];
                    // if (!pieChartCourseData[enroll.SUBJECT_CODE]) {
                    //     pieChartCourseData[enroll.SUBJECT_CODE] = [];
                    // }
                    // if (!pieChartCourseData[enroll.SUBJECT_CODE][enroll.COURSE_NUMBER]) {
                    //     pieChartCourseData[enroll.SUBJECT_CODE][enroll.COURSE_NUMBER] = 1;
                    // } else {
                    //     pieChartCourseData[enroll.SUBJECT_CODE][enroll.COURSE_NUMBER]++;
                    // }
                    // let thisPolarChartData = pieChartBuilder(coursesOrdered);
                    //     console.log(thisPolarChartData);
                    let unitsAttemptedThisTerm = 0;
                    let unitsPassedThisTerm = 0;
                    let thisTermValue = 0;
                    // Summer school.
                    if (String(term).slice(-2) === '60')
                    {
                        thisTermValue += .5;
                    } else {
                        thisTermValue += 1;
                    }
                    termsAttended += thisTermValue;

                    
                    for (const [gradeIndex, gradeValue] of Object.entries(grades['grades'])) {
                        unitsAttemptedThisTerm += grades['units'][gradeIndex];
                        if (gradeValue >= 2) { // Cs are passing.
                            unitsPassed += grades['units'][gradeIndex];
                            unitsPassedThisTerm += grades['units'][gradeIndex];
                        }
                    }
                    
                    studentChart['labels'].push(term);
                    combinationChart['labels'].push(term);
                    
                    gpaDataset.id = uuidv4();
                    gpaDataset.type = 'line';
                    gpaDataset.tension = 0.3;
                    gpaDataset.borderWidth = 3;
                    gpaDataset.label = `${student}'s GPA`;

                    // push a NUMBER (immutably if you're in React)
                    gpaDataset.data = [...(gpaDataset.data || []), Number(grades.gpa.toFixed(2))];

                    // Use ONE global gradient for the stroke (no per-point borderColor array)
                    gpaDataset.borderColor = (context) => {
                    const { chart } = context;
                    const { chartArea } = chart;
                    if (!chartArea) return;            // first layout pass
                    return getGradient(chart, chartArea);
                    };
                    gpaDataset.backgroundColor = gpaDataset.borderColor;
                    // ---- pick ONE of the following for fill ----

                    // A) No area fill (stroke only)
                    gpaDataset.fill = false;

                    // console.log('lens', gpaDataset.data.length, gpaDataset.borderColor.length);
                    // console.log(gpaDataset);
                    unitDataset['id'] = uuidv4();
                    unitDataset['tension'] = .3;
                    unitDataset['fill'] = false;
                    unitDataset['label'] = student + ' Units';

                    termUnitSum = grades['units'].reduce(function(a, b) { return a + b; }, 0);
                    studentUnitSum += termUnitSum;
                    unitDataset['data'].push(termUnitSum);

                    if (termUnitSum >= 12) {
                        termsAttended12 += thisTermValue;
                    }
                    let unitsAttemptedValue = unitsAttemptedThisTerm/thisTermValue;
                    let unitsAttemptedColor = 'orange';

                    // Get effective units taken during each semester.
                    unitsAttempted['id'] = uuidv4();
                    unitsAttempted['tension'] = .3;
                    unitsAttempted['fill'] = false;
                    unitsAttempted['label'] = student + ' Units Attempted';
                    unitsAttempted['data'].push(unitsAttemptedValue);
                    unitsAttempted['borderColor'] = unitsAttemptedColor;

                    let unitsActualValue = unitsPassedThisTerm/thisTermValue;
                    let unitsActualPercentage = unitsActualValue/unitsAttemptedValue;
                    let unitsActualColor = '';                   

                    // Get effective units taken during each semester.
                    unitsActual['id'] = uuidv4();
                    // unitDataset['cubicInterpolationMode'] = 'monotone';
                    unitsActual['tension'] = .3;
                    unitsActual['fill'] = false;
                    unitsActual['label'] = student + ' Units Actual';
                    unitsActual['data'].push(unitsActualValue);
                    unitsActual['borderColor'] = getActualUnitsColor(unitsActualValue);


                    benefitUtilization['id'] = uuidv4();
                    benefitUtilization['tension'] = .3;
                    benefitUtilization['fill'] = false;
                    benefitUtilization['label'] = student + ' Benefit Utilization';

                    let benefitValue = 0;
                    let unitsNeeded = 120;
                    // if (unitsAttemptedValue > 12) {
                    //     benefitValue = ((((unitsActualValue/unitsAttemptedValue)*15))/15).toFixed(2);
                    // } else if (unitsAttemptedValue >= 7 && unitsAttemptedValue <= 12) {
                    //     benefitValue = (((unitsActualValue/unitsAttemptedValue)*12)/15).toFixed(2);
                    // } else {
                    //     benefitValue = (((unitsActualValue/unitsAttemptedValue)*unitsAttemptedValue)/15).toFixed(2);
                    // }
                    let completionPercentage = unitsActualValue/unitsAttemptedValue;
                    let averagePassedPerTerm = Number((unitsPassed/termsAttended).toFixed(2)).toFixed(2);
                    benefitValue = ((averagePassedPerTerm*9)/120).toFixed(2);
                    // benefitUtilization['data'].push(benefitValue);
                    benefitUtilization['borderColor'] = 'blue';

                }
                
                studentChart['datasets'].push(gpaDataset);

                studentChart['datasets'].push(classAverageData);
                // studentChart['datasets'].push(unitsActual);
                // studentChart['datasets'].push(unitsAttempted);
                // studentChart['datasets'].push(benefitUtilization);
                combinationChart['datasets'].push(gpaDataset);
                // combinationChart['datasets'].push(unitsActual);
                // combinationChart['datasets'].push(unitsAttempted);
                // combinationChart['datasets'].push(benefitUtilization);

                let passRate = (unitsPassed/studentUnitSum).toFixed(2);
                let passColor = getPassRateColor(passRate);
                let averageBenefitUtil = average(benefitUtilization['data']).toFixed(2);
                // 
                let usePassRate = 0;
                if (passRate < 0.01)
                {
                    usePassRate = 0.01;
                } else  {
                    usePassRate = passRate;
                }

                dataAggregation['id'] = student.toString();
                dataAggregation['terms'] = termsAttended;
                if (termUnitSum > 0) {
                    dataAggregation['terms12'] = termsAttended12;
                }
                dataAggregation['units'] = studentUnitSum;
                dataAggregation['unitsPassed'] = parseFloat(Number(unitsPassed).toFixed(2));
                dataAggregation['passRate'] = passRate;

                if (dataAggregation['passRate'] < .75) {
                    if (!studentNotes[student.toString()]) {
                        studentNotes[student.toString()] = [];
                    }

                    studentNotes[student.toString()].push('Student pass rate is below 75%.')
                }

                dataAggregation['avgUnitsPassedPerTerm'] = Number((unitsPassed/termsAttended).toFixed(2)).toFixed(2);
                dataAggregation['benefitUtilization'] = average(benefitUtilization['data']).toFixed(2);
                dataAggregation['gpa'] = getGPA(graphElements[student][0]['grades'], graphElements[student][0]['units']).toFixed(2);
                // dataAggregation['gpa'] = (getSum(graphElements[student][0]['data'])/(graphElements[student][0]['data'].length)).toFixed(1);

                if (dataAggregation['gpa'] < 2.5) {
                    if (!studentNotes[student.toString()]) {
                        studentNotes[student.toString()] = [];
                    }

                    studentNotes[student.toString()].push('Student GPA is lower than 2.5.')
                }

                let termsAttendedNormalized = (4-dataAggregation['terms']);
                if (termsAttendedNormalized <= 0) {
                    termsAttendedNormalized = .001;
                }
                // Arbitrary value, relative to how confident the rate of pursuit is based on previous experience.
                dataAggregation['projectedBenefitUtil'] = Number((((dataAggregation['avgUnitsPassedPerTerm']*dataAggregation['terms'])/(dataAggregation['terms']*15)))*dataAggregation['passRate']).toFixed(2);
                
                if (dataAggregation['projectedBenefitUtil'] < .75) {
                    if (!studentNotes[student.toString()]) {
                        studentNotes[student.toString()] = [];
                    }

                    studentNotes[student.toString()].push('Student benefit use not optimized, under 75%.')
                }

                // if (finalDifficulty === 0) {
                //     finalDifficulty = 1+finalDifficulty;
                //     let noDataFlag = (<span style={{fontSize: '8pt'}}><br/>No Data.</span>)
                // } else {
                //     let noDataFlag = '';
                // } 
                let difficultyScore = (finalDifficulty*dataAggregation['gpa']).toFixed(2);
                
                if (hasClasses === 'Yes') {
                    let hasClassesValue = 1;
                } else {
                    let hasClassesValue = .1;
                }
                // gpaSlope['point1'] = [];
                // gpaSlope['point2'] = [];
                // gpaSlope['point1']['x'] = 0;
                // gpaSlope['point1']['y'] = 0;
                // gpaSlope['point2']['y'] = 0;
                // gpaSlope['point2']['x'] = 0;
                let pSlope = ((gpaSlope['point2']['y']-gpaSlope['point1']['y'])/(gpaSlope['point2']['x']-gpaSlope['point1']['x'])).toFixed(2);
                // console.log(pSlope);
                let pSlopeAdjusted = 1;
                if (pSlope === "NaN") {
                    pSlope = "Need data.";
                    pSlopeAdjusted = 0;
                }

                if (pSlope < -1) {
                    if (!studentNotes[student.toString()]) {
                        studentNotes[student.toString()] = [];
                    }

                    studentNotes[student.toString()].push('Student has dropped more than one full grade point.')
                }

                // let compositeScore = ((((dataAggregation['gpa']+4)/4)*10) * (((average(aboveOrBelowGrade)+4)/4)*5) * ((usePassRate+2)/2)*20).toFixed(2);
                // console.log(((average(aboveOrBelowGrade)+4) * (dataAggregation['passRate']+1) * (dataAggregation['projectedBenefitUtil']) * (difficultyScore + 1) * (usePassRate + 1)).toFixed(2));
                // Normalize and apply weights
                let gpa = parseFloat(dataAggregation['gpa']) || 0; // Ensure gpa is a valid number
                let avgGrade = parseFloat(average(aboveOrBelowGrade)) || 0; // Ensure avgGrade is a valid number
                
                let compositeScore = calculateComposite({
                    totalGPA: dataAggregation['gpa'],
                    avgGPA: 2, // If 4 is the average GPA you want to use here
                    passRate: passRate,
                    projectedDifficulty: projectedDifficulty,
                    progressSlope: pSlope,
                  });
                dataAggregation['composite'] = Number(compositeScore).toFixed(1);
                dataStatistics.push(dataAggregation);

                latestCompositeForStudent[student] = compositeScore;
                latestGPAColorForStudent[student] = getGPAColor(dataAggregation['gpa']);
                
                // studentCompositeColor[student] = getGPAColor((compositeScore3)

                // studentCompositeColor[student] = getGPAColor((compositeScore3)
                // studentCompositeColor[student] = getGPAColor((compositeScore3)


                let enrollmentDataFound = enrollment.find(e => e.ID.toString() === student.toString());
                // console.log(enrollmentDataFound);
                try {
                    let major = enrollmentDataFound.MAJOR_DESC;
                } catch {
                    let major = "N/A"
                }
                totalGPAForStudent[student] = dataAggregation['gpa'];
                let thisTableData = {
                    studentID: student,
                    hasClasses: hasClasses,
                    // classCorrelation: 1,
                    classCorrelation: gradeCorrelationCoefficient['correlationCoefficient']?.toFixed(2) || 1,
                    progressSlope: Number(pSlope),
                    termsAttended: termsAttended,
                    unitsAttempted: studentUnitSum,
                    unitsPassed: unitsPassed,
                    passRate: dataAggregation['passRate'],
                    avgPassedPerTerm: dataAggregation['avgUnitsPassedPerTerm'],
                    avgBenefitUtil: averageBenefitUtil,
                    projectedBenefitUtil: dataAggregation['projectedBenefitUtil'],
                    sparklines: <Sparklines data={gpaDataset.data} width={100} height={30} padding={4} margin={0}>
                                    <SparklinesLine color={getGPAColor(dataAggregation['gpa'])} />
                                    {/* <SparklinesReferenceLine style={{ stroke: 'white', strokeOpacity: .75, strokeDasharray: '1, 1' }} /> */}
                                        <SparklinesSpots size={2}
                                            style={{ stroke: getGPAColor(dataAggregation['gpa']), strokeWidth: 1, fill: "white" }} />
                                </Sparklines>,
                    // projectedClassDifficulty: difficultyScore,
                    aboveOrBelowGrade: average(aboveOrBelowGrade).toFixed(2),
                    totalGPA: dataAggregation['gpa'],
                    percentile: '',
                    // major: major,
                    composite: Number(compositeScore),
                };
                // const thisStudentTablePrevious = studentData[thisStudent];
                // console.log(thisStudentTablePrevious);
                // console.log("studentData");
                // console.log(studentData);
                const currentStudentData = thisTableData;
                const useStudentChart = thisStudentProjectedGrades;
                newTableData.push(currentStudentData)
                // setTableData(prevData => [
                //     ...prevData,
                //     currentStudentData
                // ]);
                if (mathCourse === '') {
                    mathCourse = '(NONE)';
                }
                if (englishCourse === '') {
                    englishCourse = '(NONE)';
                }
                // console.log("staticData");
                // console.log(studentDataStatic);

                const studentPolarChart = pieChartBuilder(pieChartData, chartColors);
                const thisStaticData = studentData[student] || [];
                // setLoadingMessage("Building student charts.");
                const individualStudentChart = (
                    <div id={student.toString()}>
                        <div
                            className={css}
                            style={{
                                top: 0,
                                display: 'flex',
                                flexDirection: 'column', // Align items vertically
                                alignItems: 'center',    // Center items vertically
                                justifyContent: 'center', // Center items horizontally
                                width: '100%',           // Ensure full width
                                border: "5px solid #333",
                                borderRadius: "10px",
                            }}
                            
                        >
                            <Table style={{ textAlign: 'center' }} columns={studentHeader} tableType="student" data={[thisTableData]} />
                        <div
                            className="center"
                            style={{
                                position: 'relative',
                                height: "350px",
                                width: "75vw",
                                marginBottom: "20px",
                                padding: 10,
                            }}
                        >
                            <center><h4 className="center">Quality Points Per Subject</h4></center>
                                <Pie data={studentPolarChart.data} options={studentPolarChart.options} />
                        </div>
                            <Table style={{ textAlign: 'center' }} chartColors={chartColors} columns={studentDataHeader} data={thisStaticData} />
                        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div
                                className="center"
                                style={{
                                    position: 'relative',
                                    height: "250px",
                                    width: "90%",
                                    backgroundColor: "#222",
                                    margin: "1em"
                                }}
                            >
                                    <Line options={chartOptions} data={studentChart} />
                            </div>
                        </div>
                        <div className="center">{projectedHTML}</div> 
                            <div className="dataSection">
                                <div className="coursesRow">{useStudentChart}</div>
                            </div>
                        </div>

                    </div>
                );
                props.studentProfile.current[student] = [];
                props.studentProfile.current[student].push(individualStudentChart);
                
                fullChartData[student] = studentChart;
                
                // fullChartData[thisStudent]?.push(individualStudentChart);
                // // chart.push()
                // setNewFullChartData((prevChart) => [
                //     ...prevChart,
                //     { id: student, chart: individualStudentChart }  // Add the ID and chart as properties
                // ]);                                // studentProjectedGrades = [];
            }
            combinationChart['labels'] = uniqueSort(combinationChart['labels']);
            // chart.push(<Line datasetIdKey={uuidv4()} key={uuidv4()} options={chartOptionsMega} data={combinationChart} ref={combinationRef} />)
            // chart.push(<button onClick={cycleData}>Cycle Data</button>)

            var columnsForStatistics = {
                // id: 'nominal',
                // terms: 'metric',
                // terms12: 'metric',
                units: 'metric',
                // unitsPassed: 'metric',
                // avgUnitsPassedPerTerm: 'metric',
                gpa: 'metric',
                composite: 'metric',
                passRate: 'metric',
                // benefitUtilization: 'metric',

                // projectedBenefitUtil: 'metric',
            }
            let stats = new Statistics(dataStatistics, columnsForStatistics);
            
            try {
                // console.log('Mean');
                let meanTerms = stats.arithmeticMean('terms');
                // console.log(meanTerms);
                // console.log(meanUnits);
                let meanUnits = stats.arithmeticMean('unitsPassed');
                // console.log(unitsPassed);
                let avgUnitsPassedPerTerm = stats.arithmeticMean('avgUnitsPassedPerTerm');
                // console.log(avgUnitsPassedPerTerm);
                let passRate = stats.arithmeticMean('passRate');
                // console.log(passRate);
                let benefitUtilization = stats.arithmeticMean('benefitUtilization');
                // console.log(benefitUtilization);

                // Build charts.
                for (const [key, value] of Object.entries(columnsForStatistics))  {
                    let chartTitle = '';
                    switch (key) {
                        case 'gpa':
                            chartTitle = 'Grade Point Average (GPA) Distribution';
                            break;
                        case 'composite':
                            chartTitle = 'Composite Score Distribution';
                            break;
                        case 'passRate':
                            chartTitle = 'Pass Rate Distribution';
                            break;
                        default:
                            chartTitle = key + ' Distribution';
                            break;
                    }
                    let chartDataforStatistic = statisticsToBarChartDataBuilder(chartTitle, stats.frequencies(key));
                    statisticsChart.push(<Bar style={{minHeight: "200px !important"}} plugins={[ChartDataLabels, glowLinePlugin]} options={statisticsChartOptions} data={chartDataforStatistic}/>);
                    if (key === 'gpa' || key === 'composite' || key === 'passRate' || key === 'units') {
                        gradeReport.push(<Bar style={{minHeight: "200px !important"}} plugins={[ChartDataLabels, glowLinePlugin]} options={statisticsChartOptions} data={chartDataforStatistic}/>);
                        gradeReport.push(<br/>);
                    }
                }
                
            } catch(e) {
                console.log(e);
            }

        })
        let groupedEnrollment = [enrollment],
        groupedResult = enrollment.reduce(function (r, a) {
            r[a.ID] = r[a.ID] || [];
            r[a.ID].push(a);
            return r;
        }, Object.create(null));
        Object.keys(groupedResult).forEach(function(enroll) {
            const studentChartItems = [];
            const studentChartHeader = [];
            try {
                
                if (!hasPreviousData.includes(String(groupedResult[enroll][0]['ID'])))
                {
                    studentChartHeader.push(
                        <div className="forecastStudent" key={uuidv4()}>
                            <h3 id={"no_enroll_" + groupedResult[enroll][0]['ID']}>
                                {groupedResult[enroll][0]['ID']}
                            </h3>
                        </div>
                    );
                    let completeNewRegistrationChart = [];
                    let newStudentProjectedGPA = [];
                    let classesRegistered = 0;
                  // Initialize registrationChart as an array
                    let registrationChart = [];
                    // Loop through groupedResult to add courses and charts
                    Object.keys(groupedResult[enroll]).forEach((enrolled) => {
                        classesRegistered++;
                        let enrolledCourse = groupedResult[enroll][enrolled]['SUBJECT_CODE'] + groupedResult[enroll][enrolled]['COURSE_NUMBER'];
                        let thisChartData = historicalGradesBarChartBuilder(enrolledCourse, coursesOrdered[enrolledCourse]['grades']);
                        let gpaSum = 0;
                        let gradeSum = 0;
                        let gradeLang = "Grades";
                
                        // Calculate GPA sum and grade sum
                        Object.keys(coursesOrdered[enrolledCourse]['grades']).forEach((grade) => {
                            gpaSum += getGradeValue(grade) * coursesOrdered[enrolledCourse]['grades'][grade];
                            gradeSum += coursesOrdered[enrolledCourse]['grades'][grade];
                        });
                
                        // Calculate average grade
                        // console.log(gradeSum);
                        let averageGrade = (gpaSum / gradeSum).toFixed(2);
                        newStudentProjectedGPA.push(averageGrade);
                        courseGPA[enrolledCourse] = averageGrade;
                
                        // Adjust gradeLang if there's only one grade
                        if (gradeSum === 1) {
                            gradeLang = "Grade";
                        }
                
                        // Push course info and chart into studentChartItems array for the current course
                        studentChartItems.push(
                            <div id={enrolledCourse} className="gradeCard" key={uuidv4()}>
                                <div className="gradeCardInner" style={{ textAlign: "center", position: "relative" }}>
                                    <div id={enrolledCourse} className="gradeBox" style={{ backgroundColor: getGPAColor(averageGrade) }}>
                                    <div className="courseHeader">
                                        <p style={{ fontWeight: 500, color: chartColors[enrolledCourse] }}>
                                        {enrolledCourse}
                                        <br />{averageGrade}
                                        </p>
                                    </div>
                                    <span style={{ display: "block", color: "black" }}>
                                        Term: {groupedResult[enroll][enrolled]['TERM_CODE']}
                                    </span>
                                    <span style={{ fontSize: "8pt", color: "black" }}>
                                        (n = {gradeSum}) {gradeLang}
                                    </span>
                                    </div>

                                    <Bar
                                    data={thisChartData}
                                    options={{
                                        maintainAspectRatio: true,
                                        scales: {
                                        x: {
                                            ticks: { color: "white" },
                                            grid: { color: "white" },
                                        },
                                        y: {
                                            ticks: { color: "white" },
                                            grid: { color: "white" },
                                        },
                                        },
                                        plugins: {
                                        legend: { labels: { color: "white" } },
                                        datalabels: {
                                            color: "white",
                                            font: { weight: "bold" },
                                        },
                                        },
                                    }}
                                    />
                                </div>
                                </div>

                        );
                    });

                    // After processing all courses, push summary data into tableNoHistoryData
                    newStudentCount++;
                    tableNoHistoryData.push({
                        studentID: groupedResult[enroll][0]['ID'],
                        history: "None",
                        projectedGPA: average(newStudentProjectedGPA).toFixed(2),
                        classesRegistered: classesRegistered,
                        concernScore: ((4 - average(newStudentProjectedGPA)) * classesRegistered).toFixed(2)
                    });

                    // // Set the registrationChart array into forecastCharts
                    // completeNewRegistrationChart.push(
                    //     <div className="gradeBoxParent">
                    //         {registrationChart}
                    //     </div>
                    // )
                    // setNewRegistrationCharts((prevData) => [...prevData, registrationChart]);
                    forecastCharts.push(
                        <div className="forecastStudentContainer" key={uuidv4()}>
                            {studentChartHeader}
                            <div className="forecastStudentGroup dataSection">
                                <div className="coursesRow">
                                    {studentChartItems}
                                </div>
                            </div>
                        </div>
                    );
                }
                    // Push the entire student chart group into registrationChart
                    
            } catch (e) {
                console.log(e);
            }
        });

        summary['connection'] = [];
        // for (const [student, notes] of Object.entries(studentNotes)) {
        //     summary['connection'].push(<h3>{student}</h3>)
        //     for (const [index, note] of Object.entries(notes)) {
        //         summary['connection'].push(<p>{index}.) {note}</p>);
        //     }
        // }
        const newGraphData = [];
        const subjectsInGraph = []; // Track all unique subjects globally
        let intermediateNodes = {}; // Track intermediate nodes globally with their corresponding subjects
        let intermediateCount = {};
        let graphNotes = {};


        
        // Step 1: Calculate similarity between students based on classes they've taken
         // Adjust this threshold as needed
        let similarityGraph = [];
        Object.keys(processed).forEach(process => {
            Object.keys(processed[process]).forEach(function(studentNode) {
                similarityGraph[studentNode] = [];
                // console.log(processed[process][studentNode]);
                Object.keys(processed[process][studentNode]).forEach(function(term) {
                    similarityGraph[studentNode] =  similarityGraph[studentNode].concat(processed[process][studentNode][term]['courses']);
                })
            })
        })
        // let similarityGraph = {};
        let subjectCounter = {};

        Object.keys(processed).forEach(process => {
            Object.keys(processed[process]).forEach(function(studentNode) {
                similarityGraph[studentNode] = []; // Initialize similarityGraph for this student
                subjectCounter[studentNode] = {}; // Initialize subjectCounter for this student

                // console.log(processed[process][studentNode]);

                Object.keys(processed[process][studentNode]).forEach(function(term) {
                    processed[process][studentNode][term]['subjectCodes'].forEach(function(subject) {
                        // Increment subject count or initialize it
                        if (!subjectCounter[studentNode][subject]) {
                            subjectCounter[studentNode][subject] = 1;
                        } else {
                            subjectCounter[studentNode][subject]++;
                        }

                        // Append subject with its counter to similarityGraph
                        similarityGraph[studentNode].push(
                            subject + subjectCounter[studentNode][subject]
                        );
                    });
                });
            });
        });
        const studentConnections = {}; // To track all students and their strongest connections

        // Perform similarity comparisons
        const studentKeys = Object.keys(similarityGraph);
        for (let i = 0; i < studentKeys.length; i++) {
            for (let j = i + 1; j < studentKeys.length; j++) {
                const studentA = studentKeys[i];
                const studentB = studentKeys[j];
        
                const classesA = new Set(similarityGraph[studentA]);
                const classesB = new Set(similarityGraph[studentB]);
        
                const intersection = new Set([...classesA].filter(x => classesB.has(x)));
                const union = new Set([...classesA, ...classesB]);
                const similarity = intersection.size / union.size;
        
                if (similarity >= similarityThreshold) {
                    // Add the similarity data to newGraphData for visualization
                    const greyValue = Math.floor(200 - (similarity * 200)); // 136 is the hex value for #888 (grey)
                    const hexColor = `#${greyValue.toString(16).padStart(2, '0')}${greyValue.toString(16).padStart(2, '0')}${greyValue.toString(16).padStart(2, '0')}`;
                    newGraphData.push({
                        data: {
                          id: `${studentA}_${studentB}`,
                          source: studentA,
                          target: studentB,
                        //   label: `Similarity: ${(similarity * 100).toFixed(2)}%`,
                          width: (similarity * 10) ** 2.5,
                          color: valToGray( (similarity * 100)), // Use the valToGray function to convert similarity to a gray color
                          connection: "similarity",
                          similarityVal: similarity, // <-- add this line
                        },
                      });
        
                    // Populate studentConnections
                    if (!studentConnections[studentA]) studentConnections[studentA] = [];
                    if (!studentConnections[studentB]) studentConnections[studentB] = [];
        
                    studentConnections[studentA].push({ student: studentB, similarity });
                    studentConnections[studentB].push({ student: studentA, similarity });
                }
            }
        }
        for (const student in studentConnections) {
            studentConnections[student].sort((a, b) => b.similarity - a.similarity);
        }
        const groups = [];
        const groupedStudents = new Set();
        let groupId = 1; // Initialize a group counter
        summary['groups'] = [];
        summary['subjects'] = [];

        // Step 3: Group students based on similarity
        while (groupedStudents.size < studentKeys.length) {
            const group = [];
            const visited = new Set();

            const startStudent = studentKeys.find(student => !groupedStudents.has(student));
            if (!startStudent) break;

            group.push(startStudent);
            groupedStudents.add(startStudent);
            visited.add(startStudent);

            while (group.length < studentKeys.length/10 && group.length < studentKeys.length) {
                let bestCandidate = null;
                let bestSimilarity = 0;

                for (const student of group) {
                    for (const connection of studentConnections[student] || []) {
                        if (
                            !groupedStudents.has(connection.student) &&
                            !visited.has(connection.student) &&
                            connection.similarity > bestSimilarity
                        ) {
                            bestCandidate = connection.student;
                            bestSimilarity = connection.similarity;
                        }
                    }
                }

                if (bestCandidate) {
                    group.push(bestCandidate);
                    groupedStudents.add(bestCandidate);
                    visited.add(bestCandidate);
                } else {
                    break;
                }
            }
            // Add the group node to the graph data
            const groupNodeId = `group_${groupId}`;
            groupColors[groupId] = `hsl(${(groupId * 60) % 360}, 70%, 60%)`; // Unique color for each group
            newGraphData.push({
                data: {
                    id: groupNodeId,
                    type: "group",
                    height: 150,
                    width: 150,
                    label: `${groupId}`,
                    color: `hsl(${(groupId * 60) % 360}, 70%, 60%)`, // Unique color for each group
                    connection: "group",
                },
            });

            summary.groups.push({ id: groupId, students: [] });

            // Create edges from students to the group node
            group.forEach((student) => {
            let studentProperties = {
                id: student,
                color: latestGPAColorForStudent[student],
            };
            summary.groups[summary.groups.length - 1].students.push(studentProperties);
                newGraphData.push({
                    data: {
                        id: `${student}_to_${groupNodeId}`,
                        source: student,
                        target: groupNodeId,
                        label: `Group ${groupId}`,
                        color: `hsl(${(groupId * 60) % 360}, 70%, 60%)`, // Match group color
                        width: 5, // Adjust edge width for visibility
                        connection: "group",
                        classes: "autorotate"
                    }
                });
            });

            // Add the group to the groups array
            groups.push({ id: groupNodeId, students: group });
            groupId++; // Increment group counter
        }        
        // Ensure groups have at least 5 members (merge smaller groups)
        for (let i = groups.length - 1; i >= 0; i--) {
            if (groups[i].students.length < 10) { // Check the length of the students array
                const lastGroup = groups.pop(); // Remove the last group
                if (groups.length > 0) {
                    // Merge the last group into the previous group
                    groups[groups.length - 1].students = groups[groups.length - 1].students.concat(lastGroup.students);
                } else {
                    groups.push(lastGroup); // Handle edge case of only one group
                }
            }
        }
        
        const values = Object.values(totalGPAForStudent).map(Number);
        const min = Math.min(...values);
        const max = Math.max(...values);
        const range = max - min;

        // Set size bounds
        const sizeMin = 100;   // smallest size (middle)
        const sizeMax = 500;  // largest size (extremes)

        // Define center (mean or median)
        const center = values.reduce((a, b) => a + b, 0) / values.length; // mean
        // Or use median:
        // const sorted = [...values].sort((a, b) => a - b);
        // const center = sorted[Math.floor(sorted.length / 2)];

        // Set curve steepness - tweakable
        const targetShapedValue = 0.75; // distance from center to 90th or 10th percentile should be 50% shape
        const distanceToMax = Math.max(
        Math.abs(max - center),
        Math.abs(min - center)
        );
        const normalizedTargetDistance = 0.8; // top/bottom 10%
        const exponent = Math.log(targetShapedValue) / Math.log(normalizedTargetDistance);
        // Process each student
        summary['subjects'] = [];
        for (const [student, graphData] of Object.entries(graphElements)) {
            const value = Number(totalGPAForStudent[student]);
            let intermediateNodeLabel;
            const normalizedDistance = Math.abs(value - center) / distanceToMax;
            const shaped = Math.pow(normalizedDistance, exponent);

            const scaledSize = sizeMin + shaped * (sizeMax - sizeMin);

            // Step 1: Find the maximum value in graphData[0]['data']
            const maxValue = (Math.max(...graphData[0]['data']) * .6).toFixed(2);
            // const maxValue = Math.max(...graphData[0]['data']);

            // Step 2: Collect all indices where the value equals maxValue
            const highestIndexes = graphData[0]['data']
                .map((value, index) => (value >= maxValue * minIndexMatch ? index : null))
                .filter(index => index !== null).sort();

            // // Step 3: Ensure at least one connection if highestIndexes is empty
            if (highestIndexes.length === 0) {
                highestIndexes.push(0); // Default to the first index
            }

            // Step 4: Handle cases based on the number of highestIndexes
            if (highestIndexes.length === 1) {  
                // If only one subject, connect directly to the student
                const subjectLabel = graphData[0]['labels'][highestIndexes[0]];
                intermediateNodeLabel = subjectLabel;
                const weight = graphData[0]['data'][highestIndexes[0]];

                // Ensure the subject node exists
                if (!subjectsInGraph.includes(subjectLabel)) {
                    subjectsInGraph.push(subjectLabel);
                    summary.subjects.push({ id: subjectLabel, color: chartColors[subjectLabel], students: [] });
                    newGraphData.push({
                        data: {
                            id: subjectLabel,
                            label: subjectLabel,
                            color: chartColors[subjectLabel],
                            width: 125,
                            height: 125,
                            type: "subject",
                            connection: "subject",
                            fontSize: "32px"
                        },
                    });
                }

                // Create a direct edge between the student and the subject
                newGraphData.push({
                    data: {
                        id: `${student}_${subjectLabel}`,
                        source: student,
                        target: subjectLabel,
                        label: `${weight}`,
                        width: `${((weight/5)**1.5)}`,
                        color: chartColors[subjectLabel],
                        connection: "subject",
                        classes: "autorotate"
                    },
                });
                // Add the student to the group for summary output.
                summary.subjects.map((subject) => {
                    if (subject.id === subjectLabel) {
                        let studentProperties = {
                            id: student,
                            color: latestGPAColorForStudent[student],
                        };
                        subject.students.push(studentProperties);
                    }
                });
            } else {
                const labels = graphData[0].labels;
                const data   = graphData[0].data;

                // All top subjects for this student
                const subjectLabels = highestIndexes.map(i => labels[i]);

                // 1) Ensure each subject exists in summary + node list
                subjectLabels.forEach(lbl => {
                if (!subjectsInGraph.includes(lbl)) {
                    subjectsInGraph.push(lbl);
                    summary.subjects.push({ id: lbl, color: chartColors[lbl], students: [] });
                    newGraphData.push({
                    data: {
                        id: lbl,
                        label: lbl,
                        color: chartColors[lbl] || "#fff",
                        nodeShape: "triangle",
                        nodeWidth: 200,
                        nodeHeight: 200,
                        type: "subject",
                        connection: "subject",
                        classes: "autorotate",
                    },
                    });
                }
                });

                // 2) Add THIS student to EACH of those subjects
                subjectLabels.forEach(lbl => {
                const subj = summary.subjects.find(s => s.id === lbl);
                if (subj) {
                    subj.students.push({
                    id: student,
                    color: latestGPAColorForStudent[student],
                    });
                }
                });

                // 3) (unchanged) Build intermediate node id/label
                const intermediateNodeId = [...subjectLabels].sort().join("_intermediate");
                intermediateNodeLabel = subjectLabels.join(", ");

                // 4) Create intermediate node if needed, connect subjects -> intermediate
                if (!intermediateNodes[intermediateNodeId]) {
                graphNotes[intermediateNodeId] = { label: intermediateNodeLabel, students: [student] };
                intermediateCount[intermediateNodeId] = 1;

                intermediateNodes[intermediateNodeId] = {
                    id: intermediateNodeId,
                    label: intermediateNodeLabel,
                    height: 125,
                    width: 125,
                    color: "#fff",
                    type: "subject",
                    connection: "subject",
                };
                newGraphData.push({ data: intermediateNodes[intermediateNodeId] });

                subjectLabels.forEach(lbl => {
                    const w = data[labels.indexOf(lbl)];
                    newGraphData.push({
                    data: {
                        id: `${lbl}_${intermediateNodeId}`,
                        source: lbl,
                        target: intermediateNodeId,
                        label: String(w),
                        width: String((w / 5) ** 1.5),
                        color: chartColors[lbl] || "#fff",
                        connection: "subject",
                    },
                    });
                });
                } else {
                intermediateCount[intermediateNodeId]++;
                intermediateNodes[intermediateNodeId].label =
                    `${intermediateNodeLabel} (${intermediateCount[intermediateNodeId]})`;
                graphNotes[intermediateNodeId].note =
                    `${intermediateNodeLabel} has ${intermediateCount[intermediateNodeId]} connections, ${minIndexMatch * 100}% of quality points are similar.`;
                graphNotes[intermediateNodeId].students.push(student);
                }

                // Connect intermediate -> student
                newGraphData.push({
                data: {
                    id: `${intermediateNodeId}_${student}`,
                    source: intermediateNodeId,
                    target: student,
                    label: String(maxValue),
                    width: String(maxValue),
                    color: latestGPAColorForStudent[student],
                    connection: "subject",
                },
                });
            }
            
            newGraphData.push({
                data: { 
                    id: student, 
                    type: "student", 
                    height: scaledSize,
                    width:  scaledSize,
                    label: `ID: ${student}\nGPA: ${totalGPAForStudent[student]}\nSubjects: ${intermediateNodeLabel}`, 
                    labelSize: "36px",
                    color: getGPAColor(totalGPAForStudent[student]) 
                },
            });

        }
        if (true) {
            const calculateJaccardSimilarity = (setA, setB) => {
                const intersection = new Set([...setA].filter((x) => setB.has(x)));
                const union = new Set([...setA, ...setB]);
                return intersection.size / union.size;
            };
            
            // Step 1: Group SUBJECT_CODE by students
            const studentSubjects = {};
                try {
                    enrollment.forEach(({ ID, SUBJECT_CODE, COURSE_NUMBER }) => {
                        if (!studentSubjects[ID]) {
                        studentSubjects[ID] = new Set();
                        }
                        studentSubjects[ID].add(SUBJECT_CODE + COURSE_NUMBER);
                    });
                } catch (e) {
                    console.log(e);
                }
                
                // Step 2: Calculate similarity between students
                const studentIds = Object.keys(studentSubjects);
                const similarityMatrix = [];
                
                for (let i = 0; i < studentIds.length; i++) {
                    if (!newGraphData.some((el) => el.data.id === studentIds[i])) {
                        newGraphData.push({
                        data: { id: studentIds[i], label: `New: ${studentIds[i]}`, width: 50, height: 50, type: "student", connection: "enrollment", color: "#555" },
                    });
                }
                    for (let j = i + 1; j < studentIds.length; j++) {
                    const idA = studentIds[i];
                    const idB = studentIds[j];
                    const similarity = calculateJaccardSimilarity(
                        studentSubjects[idA],
                        studentSubjects[idB]
                    );
                
                    similarityMatrix.push({
                        studentA: idA,
                        studentB: idB,
                        similarity,
                    });
                    }
                }
                
                // Step 3: Build graph with similarity-based edges

                //   studentIds.forEach((id) => {
                //     newGraphData.push({
                //       data: { id, label: `Student ${id}`, type: "student" },
                //     });
                //   });
                // Add student node if not already added
                
                similarityMatrix.forEach(({ studentA, studentB, similarity }) => {
                    if (similarity > .15) {
                    newGraphData.push({
                        data: {
                        id: `edge-${studentA}-${studentB}`,
                        label: similarity.toFixed(2) * 100 + "%",
                        source: studentA,
                        target: studentB,
                        color: valToGray(similarity * 100),
                        width: (similarity * 100)^2,
                        similarity,
                        connection: "enrollment",
                        },
                    });
                    }
                });
                // -----------------------------
                // STEP: K-Means clustering
                // -----------------------------
                (() => {
                // 1) Build feature space (vocabulary of subjects)
                const vocabSet = new Set();
                Object.values(subjectCounter).forEach(map => {
                    Object.keys(map).forEach(s => vocabSet.add(s));
                });
                const vocab = Array.from(vocabSet);
                const V = vocab.length;

                // Early exit if no features
                if (V === 0 || studentKeys.length === 0) return;

                // 2) Build data matrix: one row per student, columns = subject counts
                const studentIndex = new Map(studentKeys.map((id, i) => [id, i]));
                const X = studentKeys.map(id => {
                    const counts = subjectCounter[id] || {};
                    const row = new Float32Array(V);
                    for (let c = 0; c < V; c++) row[c] = counts[vocab[c]] || 0;
                    return row;
                });

                // Optional: L2 normalize rows (helps k-means on count data)
                const l2norm = v => Math.sqrt(v.reduce((s, x) => s + x*x, 0));
                for (let i = 0; i < X.length; i++) {
                    const n = l2norm(X[i]);
                    if (n > 0) for (let j = 0; j < V; j++) X[i][j] /= n;
                }

                // 3) K = length/10 (rounded); at least 1, at most N
                const N = X.length;
                const K = Math.max(1, Math.min(N, Math.round(N / 10)));

                // 4) K-Means (simple implementation)
                function kmeans(data, k, maxIters = 50) {
                    // console.log(k, data);
                    const n = data.length;
                    const d = data[0].length;
                    // init centroids by picking k distinct random points
                    const taken = new Set();
                    const centroids = Array.from({ length: k }, () => {
                    let idx;
                    do { idx = Math.floor(Math.random() * n); } while (taken.has(idx));
                    taken.add(idx);
                    return Float32Array.from(data[idx]);
                    });

                    const assign = new Int32Array(n).fill(-1);
                    const dist2 = (a, b) => {
                    let s = 0;
                    for (let i = 0; i < d; i++) { const diff = a[i] - b[i]; s += diff*diff; }
                    return s;
                    };

                    for (let iter = 0; iter < maxIters; iter++) {
                    // Assignment step
                    let changed = 0;
                    for (let i = 0; i < n; i++) {
                        let best = 0, bestD = dist2(data[i], centroids[0]);
                        for (let c = 1; c < k; c++) {
                        const dd = dist2(data[i], centroids[c]);
                        if (dd < bestD) { bestD = dd; best = c; }
                        }
                        if (assign[i] !== best) { assign[i] = best; changed++; }
                    }
                    if (changed === 0) break;

                    // Update step
                    const sums = Array.from({ length: k }, () => new Float64Array(d));
                    const counts = new Int32Array(k);
                    for (let i = 0; i < n; i++) {
                        const c = assign[i];
                        counts[c]++;
                        const xi = data[i];
                        for (let j = 0; j < d; j++) sums[c][j] += xi[j];
                    }
                    for (let c = 0; c < k; c++) {
                        if (counts[c] === 0) {
                        // Reinitialize empty cluster to a random point
                        const idx = Math.floor(Math.random() * n);
                        centroids[c] = Float32Array.from(data[idx]);
                        } else {
                        for (let j = 0; j < d; j++) centroids[c][j] = sums[c][j] / counts[c];
                        }
                    }
                    }
                    return { assign, centroids };
                }

                const { assign } = kmeans(X, K);

                // 5) Emit cluster nodes + edges (connection: "kmeans")
                // Build clusters -> list of student ids
                const clusters = Array.from({ length: K }, () => []);
                for (let i = 0; i < N; i++) clusters[assign[i]].push(studentKeys[i]);

                // You can keep a separate summary, or reuse summary.groups; here we add summary.kmeans
                if (!summary.kmeans) summary.kmeans = [];
                
                clusters.forEach((members, idx) => {
                    const clusterKey = idx + 1;

                    // Flatten rows for all members in this cluster:
                    const clusterRows = members.flatMap((sid) => studentData[sid] ?? []);

                    // Build stats + chart datasets:
                    const clusterStats = buildClusterStatsAndCharts(clusterRows, {
                        topSubjects: 15,
                        gradeEarnedIsPerUnit: true,
                    });

                    // Persist for dashboards:
                    networkInfo.kmeans = networkInfo.kmeans || {};
                    networkInfo.kmeans[clusterKey] = networkInfo.kmeans[clusterKey] || {};

                    networkInfo.kmeans[clusterKey].stats = clusterStats.cluster;
                    networkInfo.kmeans[clusterKey].termSeries = clusterStats.termSeries;
                    networkInfo.kmeans[clusterKey].subjects = clusterStats.subjects;         // full
                    networkInfo.kmeans[clusterKey].subjectsTop = clusterStats.subjectsTop;   // trimmed
                    networkInfo.kmeans[clusterKey].charts = clusterStats.chartjs;            // Chart.js-ready
                    // Your existing graph code continues unchanged...
                    const conn = computeClusterConnectednessFromElements(newGraphData, members, {
                      includeConnections: new Set(["similarity"]),
                      directed: false,
                    });
                    networkInfo.kmeans[clusterKey].connectedness = {
                      ...conn,
                      cohesion: cohesionScore(conn),
                    };
                    console.log(networkInfo['kmeans'][clusterKey]);
                    const clusterId = `kmeans_${idx + 1}`;
                    const hue = (idx * 360 / K) % 360;
                    kMeansColors[idx] = `hsl(${hue}, 70%, 55%)`;
                    // kMeansColors[idx].push(`hsl(${hue}, 70%, 55%)`)
                    // Cluster node
                    newGraphData.push({
                    data: {
                        id: clusterId,
                        type: "kmeans",
                        shape: "triangle",
                        height: 400,
                        width: 400,
                        label: `K${idx + 1}\nStudents: ${members.length}\nAvg. Degree: ${networkInfo.kmeans[clusterKey].connectedness.avgDegree.toFixed(2)}\nDensity: ${networkInfo.kmeans[clusterKey].connectedness.density.toFixed(2)}\nCohesion: ${networkInfo.kmeans[clusterKey].connectedness.cohesion.toFixed(2)}`,
                        labelSize: "100px",
                        color:  kMeansColors[idx],
                        connection: "kmeans",
                        classes: "autorotate"
                    },
                    });

                    // Summary record
                    const entry = { id: idx + 1, students: [] };
                    summary.kmeans.push(entry);

                    // Edges: student -> cluster
                    members.forEach(student => {
                    entry.students.push({ id: student, color: latestGPAColorForStudent[student] });
                    newGraphData.push({
                        data: {
                        id: `${student}_to_${clusterId}`,
                        source: student,
                        target: clusterId,
                        label: `K${idx + 1}`,
                        color: `hsl(${hue}, 70%, 55%)`,
                        width: 4,
                        connection: "kmeans",
                        classes: "autorotate"
                        }
                    });
                    });
                });
                })();

        } else {
            console.log(enrollment.length)
        }

        const uniqueTerms = new Set();
        fullChartData.forEach(entry => {
            entry.labels.forEach(term => uniqueTerms.add(term));
        });
        const sortedLabels = Array.from(uniqueTerms).sort(); // Sort terms in order
        
        // Step 2: Aggregate GPAs for each term
        const termGPAData = {}; // { term: [gpas] }
        
        fullChartData.forEach(entry => {
            entry.labels.forEach((term, index) => {
                if (!termGPAData[term]) termGPAData[term] = [];
        
                entry.datasets.forEach(dataset => {
                    if (dataset.id) { // Ignore "Average Class GPA" dataset
                        termGPAData[term].push(dataset.data[index]);
                    }
                });
            });
        });
        
        const averageGPA = sortedLabels.map(term => {
            const gpas = termGPAData[term] || [];
            return average(gpas); // Calculate average GPA for each term
        });
        const pointColors = averageGPA.map(v => getGPAColor(v));

        // Step 4: Convert to Chart.js format
        const statisticsChartDataset = {
            labels: sortedLabels,
            datasets: [
                {
                    label: "Cohort GPA Over Time",
                    data: averageGPA,
                    borderColor: "#fff",
                    backgroundColor: getGPAColor(average(averageGPA)),
                    pointBackgroundColor: pointColors,
                    pointBorderColor: pointColors,
                     segment: {
                        borderColor: (ctx) => pointColors[ctx.p0DataIndex] ?? "#ccc"
                    },
                    tension: 0.3,
                    yAxisID: "y",
                    fill: false,
                    align: "top"
                }
            ]
        };
        const gpaArray = dataStatistics.map((d) => {
            return d.gpa;
        });
        newTableData.forEach((student, i) => {
            student.percentile = percentile(gpaArray, student.totalGPA).toFixed(2);
        });
        let studentProfile = props.studentProfile;
        setLoadingMessage("Done.");
        setLoading(false);
        // console.log(props.studentProfile);
        let fullStudentChartData = (
            <div class="dataSection" id={"studentGradeAcademyData"}>
                {<Line options={chartOptionsMega} plugins={[ChartDataLabels, glowLinePlugin]} data={statisticsChartDataset} />}
            </div>
        )
        gradeReport.unshift(<Line options={chartOptionsMega} plugins={[ChartDataLabels, glowLinePlugin]} data={statisticsChartDataset} />);
        forecastFinal = (
            <div class="dataSection" id={"studentForecast"}>
                <Table chartColors={chartColors} key={uuidv4()} style={{textAlign: 'center'}} columns={forecastTable} studentProfile={props.studentProfile} data={tableNoHistoryData}/>
            </div>);
        forecastChart = (
                <div  className="forecastStudentContainer" style={{textAlign: 'center'}}>
                    {Object.keys(forecastCharts).map((key) => (
                        <div key={key}>
                            {forecastCharts[key]}
                        </div>
                    ))}
                </div>
        );
        classStatisticsFinal = (<div class="dataSection mx-auto" id="classStatistics" style={{paddingBottom: "50px", justifyContent: "center", alignItems: "center", textAlign: "center"}}>
            <div className="coursesRow">
                {Object.keys(courseData).map((key) => (
                    <div key={key}>
                        {courseData[key]}
                    </div>
                ))}
            </div>
        </div>);
        classTableFinal = (<div class="dataSection" id={"classTable"}>
            <Table chartColors={chartColors} key={uuidv4()}  style={{textAlign: 'center'}} columns={tableHeaderClass} studentProfile={props.studentProfile} data={tableData}/>
        </div>)
        tutorChart = (
            <div  className="tutorContainer" style={{textAlign: 'center'}}>
                <Table chartColors={chartColors} studentProfile={props.studentProfile} key={uuidv4()} style={{textAlign: 'center'}} columns={tutorDataHeader} data={tutorData}/>
            </div>
    );
    let graphData = (<>
    <CyGraph networkInfo={networkInfo} groupColors={groupColors} studentData={newTableData} setLoading={setLoading} chartColors={chartColors} kMeansColors={kMeansColors} featureVectors={props.featureVectors} studentProfile={props.studentProfile} summary={summary} graphNotes={graphNotes} key={uuidv4()} elements={newGraphData} />
    </>)

    let studentDataTable = (
    <>
        <DataTable studentProfile={props.studentProfile} newTableData={newTableData} /> 
    </>);
    return { 
        studentProfile, 
        fullStudentChartData, 
        statisticsChart, 
        newTableData, 
        forecastFinal, 
        forecastChart, 
        classStatisticsFinal, 
        classTableFinal, 
        tutorChart, 
        graphData,
        gradeReport,
        studentDataTable
    };
    }, [courses, enrollment, processed]);
    useEffect(() => {
        if (hasRunOnce.current) return;
        hasRunOnce.current = true;
        props.academyData.current = buildAcademyData();
    }, [])
   


    
    // useEffect(() => {
    //     if (props.dataSectionToRender === "forecast") {
    //         setDataSections(
    //         <div class="dataSection" id={"studentForecast"}>
    //             <h3 id={""} style={{clear: 'both', textAlign: 'center'}}>Forecast Table</h3>
    //             <Table key={uuidv4()} style={{textAlign: 'center'}} columns={forecastTable} data={tableNoHistoryData}/>
    //             <h3 id={""} style={{clear: 'both', textAlign: 'center'}}>Forecast Charts</h3>
    //             <div  className="forecastStudentContainer" style={{textAlign: 'center'}}>
                    
    //                 {Object.keys(forecastCharts).map((key) => (
    //                     <div key={key}>
    //                         {forecastCharts[key]}
    //                     </div>
    //                 ))}
    //             </div>
    //         </div>);
    //         setIsModalOpen(true);
    //     } else if (props.dataSectionToRender === "classStatistics") {
    //         setDataSections(
    //         );
    //         setIsModalOpen(true);
    //     } else if (props.dataSectionToRender === "classTable") {
    //         setDataSections(
    //         ;
    //         setIsModalOpen(true);
    //     } else if (props.dataSectionToRender === 'student') {
    //         console.log("student to load");
    //         setIsModalOpen(true);
    //     }
    // }, []);
    const gridContent = (
        <div style={{ padding: "10px", textAlign: "center" }}>
            {/* Student Summary */}
            <section className="action-card glass tint-forest" >
            <h3 style={{ color: "white" }}>Student Summary</h3>
            <p>
                See a summary of each student's performance.
            </p>
            <div
                style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "24px",
                marginTop: "24px",
                }}
            >
                {/* Text / Card */}
                <div
                className="action-card glass tint-green"
                style={{
                    maxWidth: "420px",
                    padding: "20px",
                    flex: "1 1 300px",
                    minWidth: "280px",
                }}
                >
                <p style={{ marginBottom: "20px" }}>
                    Get an at-a-glance view of individual students and their performance.
                </p>
                <p style={{ color: "#f8f8f8" }}>
                    Having a nearly immediate view of student performance allows educators to quickly identify trends, strengths, and areas needing support without digging through complex reports. This streamlined insight helps teachers and counselors make faster, data-informed decisions to improve academic outcomes.
                </p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Student Summary"
                    onClick={() =>
                        openFloatingModal(
                        "Student Summary",
                        props.academyData.current.studentDataTable
                        )
                    }
                    />
                </div>
                </div>

                {/* Image */}
                <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                <img
                    src="https://grade.academy/wp-content/uploads/2025/11/summary-scaled.jpg"
                    alt="Image of the summary dashboard."
                    style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 0 12px rgba(0,0,0,0.4)",
                    }}
                />
                </div>
            </div>
            </section>

            <section  className="action-card glass tint-purple" style={{ textAlign: "center", margin: "40px 0" }}>
                <h3 style={{ color: "white" }}>Social Analysis</h3>
                <p style={{ color: "#f8f8f8" }}>
                    Explore student networks and peer group impacts.
                </p>

                <div
                    style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: "24px",
                    marginTop: "24px",
                    }}
                >
                    {/* Text / Card */}
                    
                    {/* Image */}
                    <div style={{ flex: "1 1 300px", minWidth: "280px", }}>
                    <img
                        src="https://grade.academy/wp-content/uploads/2025/11/social-scaled.jpg"
                        alt="Image of the social analysis dashboard."
                        style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "12px",
                        boxShadow: "0 0 12px rgba(0,0,0,0.4)",
                        }}
                    />
                    </div>
                    <div
                    className="action-card glass tint-purple"
                    style={{
                        maxWidth: "420px",
                        padding: "20px",
                        flex: "1 1 300px",
                        minWidth: "280px",
                    }}
                    >
                    <p style={{ marginBottom: "20px" }}>
                        Look at the connectedness of a cohort and easily form peer mentorship
                        groups, and connect people with similar interests.
                    </p>
                    <p style={{ color: "#f8f8f8" }}>
                        A broad view of social network analysis helps educators quickly see how students are connected, who might be isolated, and which groups foster collaboration. This insight supports stronger peer mentorship, inclusion, and community-building efforts that enhance student engagement and belonging.
                    </p>
                    <div className="card-footer">
                        <ExploreButton
                        label="Explore Social Analysis"
                        onClick={() =>
                            {
                            // alert("This may take a few seconds to load.")
                            openFloatingModal(
                                    "Social Analysis",
                                    props.academyData.current.graphData
                                );
                            }
                        }
                        />
                    </div>
                    </div>

                </div>
                </section>

            {/* Overall Demographic */}
            <section>
            <h3 style={{ color: "white" }}>Overall Demographic</h3>
            <p style={{ color: "#f8f8f8" }}>
                Understand trends, performance, and statistics across the entire student population.
            </p>
            <div className="action-grid">
                <div className="action-card glass tint-indigo">
                <p>Dig into detailed grade reports for targeted insights.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Overall Demographic"
                    onClick={() =>
                        openFloatingModal(
                        "Grade Report Analysis",
                        props.academyData.current.gradeReport
                        )
                    }
                    />
                </div>
                </div>
            </div>
            </section>

            {/* New Students */}
            <section>
            <h3 style={{ color: "white" }}>New Students</h3>
            <p style={{ color: "#f8f8f8" }}>
                Forecast success and identify risks for incoming students.
            </p>
            <div className="action-grid-stack">
                <div className="action-card glass tint-lime">
                <h3>Forecast Table</h3>
                <p>Predictions for new student success and risk.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Forecast Table"
                    onClick={() =>
                        openFloatingModal(
                        "Forecast Table",
                        props.academyData.current.forecastFinal
                        )
                    }
                    />
                </div>
                </div>

                <div className="action-card glass tint-lime">
                <h3>Forecast Charts</h3>
                <p>Visual projections of upcoming student performance.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Forecast Charts"
                    onClick={() =>
                        openFloatingModal(
                        "Forecast Charts",
                        props.academyData.current.forecastChart
                        )
                    }
                    />
                </div>
                </div>
            </div>
            </section>

            {/* Class Data */}
            <section>
            <h3 style={{ color: "white" }}>Class Data</h3>
            <p style={{ color: "#f8f8f8" }}>
                Break down results and trends at the class level.
            </p>
            <div className="action-grid-stack">
                <div className="action-card glass tint-amber">
                <h3>Class Statistics</h3>
                <p>Analyze performance by class with aggregated stats.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Class Statistics"
                    onClick={() =>
                        openFloatingModal(
                        "Class Statistics",
                        props.academyData.current.classStatisticsFinal
                        )
                    }
                    />
                </div>
                </div>

                <div className="action-card glass tint-amber">
                <h3>Class Table</h3>
                <p>Detailed tabular breakdown of student class data.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Class Table"
                    onClick={() =>
                        openFloatingModal(
                        "Class Table",
                        props.academyData.current.classTableFinal
                        )
                    }
                    />
                </div>
                </div>
            </div>
            </section>

            {/* Additional Insights */}
            <section>
            <h3 style={{ color: "white" }}>Additional Insights</h3>
            <p style={{ color: "#f8f8f8" }}>
                Dive into tutoring outcomes, social analysis, and grade report details.
            </p>
            <div className="action-grid">
                <div className="action-card glass tint-coral">
                <h3>Tutor Center</h3>
                <p>Insights on tutoring sessions and student outcomes.</p>
                <div className="card-footer">
                    <ExploreButton
                    label="Explore Tutor Center"
                    onClick={() =>
                        openFloatingModal(
                        "Tutor Center",
                        props.academyData.current.tutorChart
                        )
                    }
                    />
                </div>
                </div>
            </div>
            </section>

            {/* Compliance */}
            <section>
            <h3 style={{ color: "white" }}>Compliance Information</h3>
            <p style={{ color: "#f8f8f8" }}>
                Access the policies and regulations guiding data privacy and student protection.
            </p>
            <div className="action-grid-stack">
                {[
                { t: "FERPA Compliance", u: "/ferpa.html" },
                { t: "COPPA Compliance", u: "/coppa.html" },
                { t: "Privacy Policy", u: "/privacy.html" },
                { t: "Data Handling", u: "/data-handling.html" },
                ].map(({ t, u }) => (
                <div key={t} className="action-card glass tint-silver on-dark">
                    <h3>{t}</h3>
                    <p>Tap to view details and requirements.</p>
                    <div className="card-footer">
                    <ExploreButton
                        label={`Explore ${t}`}
                        onClick={() => openHtmlDocModal(u, t)}
                    />
                    </div>
                </div>
                ))}
            </div>
            </section>
        </div>
        );


    return (
        <>
          {loading ? (
            <div className="ultimateCenter" style={{marginTop: "20%"}}>
              <l-dot-stream size="150" speed="1.5" color="white" />
            </div>
          ) : (
            <>
                <div className="d-flex justify-content-center">
                <Button
                    onClick={reloadConfirm}
                    variant="outline-light"
                    style={{ margin: "5px", zIndex: 1000 }}
                    disabled={reloading}
                >
                   ↻
                </Button>
                </div>
                {gridContent}
            </>
      )}
      </>
    );
});
export default GradeAcademy;